<template>
	<div>
		<step-navigation-title
			:key="navigationKey"
			:steps="visibleSteps"
			:currentStep="currentStep"
			@stepClicked="stepClicked"
		/>
		<br />
		<br />
		<div v-show="currentStep == 1" class="screenMargin">
			<p class="stepName">{{ $t("pages.newInviteSupplier.steps.inviteData") }}</p>
			<b-col>
				<k-crud
					ref="InviteDetailsKCrud"
					@blur="handleBlur"
					@fieldChange="fieldChange"
					:fields="inviteDetailsStructure"
					:data="inviteDetails"
					:key="inviteDetailsKey"
				>
					<template v-slot:customField>
						<b-input-group>
							<b-form-file
								ref="file-input"
								id="uploadFileInput"
								v-model="getFileName"
								:placeholder="getFileName ? getFileName : $t('commons.placeholders.getFile')"
								@change="fileChange"
								:disabled="screenType != $inviteTabsType.inviteCreation"
							></b-form-file>
							<b-input-group-append>
								<b-button
									v-if="getFileName != null && screenType == $inviteTabsType.inviteCreation"
									@click="clearFiles"
									variant="outline-danger"
									v-b-tooltip.:hover="{
										title: $t('commons.hovers.erase'),
										customClass: 'custom-tooltip',
										interactive: false,
										placement: 'bottom'
									}"
									>X
								</b-button>
								<b-input-group-text class="mousePointer">
									<b-icon
										:icon="getFileName ? 'download' : 'upload'"
										class="mousePointer"
										@click="clickFileIcon"
										v-b-tooltip.hover="{
											title: getFileName ? $t('commons.hovers.downloadFile') : $t('commons.hovers.uploadFile'),
											customClass: 'custom-tooltip',
											interactive: false,
											placement: 'bottom'
										}"
									/>
								</b-input-group-text>
							</b-input-group-append>
						</b-input-group>
					</template>
				</k-crud>
				<div style="height: 0; max-width: 70%">
					<label v-show="workflowTypeOrientationMessage" class="ml-3">{{
						"* " + workflowTypeOrientationMessage
					}}</label>
				</div>
			</b-col>
		</div>
		<div v-show="currentStep == 2" class="screenMargin">
			<p class="stepName">{{ $t("pages.newInviteSupplier.steps.registrationData") }}</p>
			<b-col>
				<k-crud
					ref="SupplierDetailsKCrud"
					:fields="supplierDetailsStructure"
					:data="supplierData"
					@blur="handleBlur"
					:key="supplierDetailsKey"
				/>
			</b-col>
		</div>
		<div v-show="currentStep == 3" class="screenMargin">
			<p class="stepName mb-4">{{ $t("commons.contact.data") }}</p>
			<b-col>
				<k-crud :key="dataContactKey" :data="dataContact" :fields="contactStructure" class="session-contact-bank" />
			</b-col>
			<p class="stepName mt-3">{{ $t("commons.bankData") }}</p>
			<b-col>
				<b-row>
					<b-col class="name-bank">
						<k-crud
							ref="BankInfoOne"
							:key="dataBankKey"
							:fields="structureRowOne"
							:data="dataBank"
							style="margin-top: 0 !important"
							class="kcrud"
						/>
					</b-col>
					<b-col class="auto-complete-bank">
						<label>{{ bankFieldLabel("bank", $t("commons.bank")) }}</label>
						<div class="auto-complete-container p-fluid">
							<AutoComplete
								:placeholder="$t('commons.placeholders.typeAndSelect')"
								class="auto-complete"
								field="description"
								v-model="dataBank.bankDescription"
								:suggestions="standardListBanks"
								@complete="searchBank($event)"
								@item-select="selectBankSuggestion($event)"
								@clear="clearBankSuggestion()"
								forceSelection
								:disabled="!isBankFieldEditable('bank')"
								:style="
									isBankFieldRequiredLabel('bank') && !dataBank.bankDescription
										? 'border: .5px solid red; border-radius: 5px'
										: ''
								"
							/>
							<p class="text-danger small mt-1" v-if="isBankFieldRequiredLabel('bank') && !dataBank.bankDescription">
								{{ $t("messages.fieldIsMandatory") }}
							</p>
						</div>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="4" class="auto-complete-agency p-fluid">
						<label>{{ bankFieldLabel("agency", $t("commons.agency")) }}</label>
						<div class="auto-complete-container">
							<AutoComplete
								:placeholder="$t('commons.placeholders.typeAndSelect')"
								class="auto-complete"
								field="description"
								v-model="dataBank.agencyDescription"
								:suggestions="standardListAgencies"
								@complete="searchAgency($event)"
								@item-select="selectAgencySuggestion($event)"
								:disabled="!isBankFieldEditable('agency') || (!isBankProcess() && !agenciesList.length)"
								forceSelection
								:style="
									isBankFieldRequiredLabel('agency') && !dataBank.agencyDescription
										? 'border: .5px solid red; border-radius: 5px'
										: ''
								"
							/>
							<p
								class="text-danger small mt-1"
								v-if="isBankFieldRequiredLabel('agency') && !dataBank.agencyDescription"
							>
								{{ $t("messages.fieldIsMandatory") }}
							</p>
						</div>
					</b-col>
					<b-col cols="2" style="margin-left: -1.3rem" class="p-fluid">
						<label>{{ bankFieldLabel("agency", $t("commons.agencyDigit")) }}</label>
						<InputMask
							class="input-text"
							id="agencyDigit"
							placeholder="*"
							mask="*"
							v-model="dataBank.agencyDigit"
							:disabled="!isBankFieldEditable('agency') || (!isBankProcess() && !agenciesList.length)"
							:style="
								isBankFieldRequiredLabel('agency') && !dataBank.agencyDigit ? 'border: 1px solid red;' : ''
							"
						/>
						<p class="text-danger small mt-1" v-if="isBankFieldRequiredLabel('agency') && !dataBank.agencyDigit">
							{{ $t("messages.fieldIsMandatory") }}
						</p>
					</b-col>
					<b-col cols="6">
						<k-crud
							ref="BankInfoTwo"
							:key="dataBankKey"
							:fields="structureRowTwo"
							:data="dataBank"
							style="margin-top: 0 !important"
							class="kcrud"
						/>
					</b-col>
				</b-row>
			</b-col>
		</div>
		<div v-show="currentStep == 4" class="screenMargin customAdjustment">
			<p class="stepName" style="margin-bottom: 22px; padding-left: 16px">
				{{ $t("commons.organizationalStructure") }}
			</p>

			<div class="wrapper">
				<b-form-group>
					<k-tree-view
						:nodes="companyOptions"
						@onChange="onChangeCompany"
						:key="companiesKey"
						:disabled="!editCompaniesPermission"
					/>
				</b-form-group>
			</div>
			<b-form-checkbox
				id="chkSelectAllCompany"
				:disabled="!editCompaniesPermission"
				:checked="isSelectAllChecked"
				@change="selectAllCompanies"
				class="mb-3 selectAllCompanies"
			>
				{{ $t("commons.selectAll") }}
			</b-form-checkbox>

			<p class="stepName" style="margin-bottom: 0; padding-left: 16px">{{ $t("commons.productFamily") }}</p>
			<b-row>
				<b-col cols="6">
					<k-crud :data="filter" :fields="filterStructure" />
				</b-col>
				<b-col cols="6">
					<k-button
						class="filterBtn ml-3"
						variant="outline-secondary"
						@click="cleanFilter"
						:text="$t('buttons.clearFilters')"
					/>
					<k-button class="filterBtn" variant="info" @click="applyFilter" :text="$t('buttons.applyFilters')" />
				</b-col>
			</b-row>
			<div class="family-tree-container">
				<k-family-tree
					class="familyTree"
					:showChecks="true"
					:isDisabled="screenType != $inviteTabsType.inviteCreation || this.inviteRehomologation"
					:addPermission="editFamiliesPermission"
					:deletePermission="editFamiliesPermission"
					:item="familiesWithStatus"
					:key="familiesKey"
					:showVerticalLines="true"
					:showGripButton="true"
					:screenType="'Convite'"
					@onChange="onChangeFamily"
					@toggle="toggleFamily"
					hideFirstAdd
				/>
			</div>
			<b-row class="saveChangesRow" v-if="screenType == $inviteTabsType.inviteProcess">
				<b-col cols="12"> </b-col>
			</b-row>
		</div>
		<div v-show="currentStep == 5" class="screenMargin tableAdjustment">
			<p class="stepName" style="padding-left: 0px">{{ $t("commons.bindingSupplierClient") }}</p>
			<b-row>
				<b-col cols="12">
					<k-crud
						style="padding-left: 0px; padding-right: 0px"
						:data="supplierFilter"
						:fields="supplierFilterStructure"
						:disabled="this.screenType != this.$inviteTabsType.inviteCreation"
					/>
				</b-col>
				<b-col cols="12">
					<b-row>
						<b-col cols="12">
							<k-button
								class="filterBtn2"
								variant="info"
								@click="applySupplierFilter"
								:text="$t('buttons.search')"
								:disabled="this.screenType != this.$inviteTabsType.inviteCreation"
								style="margin-left: 10px"
							/>
							<k-button
								class="filterBtn2 ml-3"
								variant="outline-secondary"
								@click="cleanSupplierFilter"
								:text="$t('buttons.cleanSearch')"
								:disabled="this.screenType != this.$inviteTabsType.inviteCreation"
							/>
						</b-col>
					</b-row>
				</b-col>
			</b-row>

			<k-list-radio
				:fields="supplierParentFields"
				:items="suppliers"
				:selected="selectedSupplierParent"
				@actionSelectParent="setSelectedSupplierParent"
				middleCRUD
			/>
			<k-info-box
				v-if="this.suppliers.length <= 0"
				type="success"
				:closeButton="false"
				:info="infoBoxSupplierParent.message"
				id="messages.infoBox"
			/>
			<b-col cols="12" v-show="this.supplierParentEntails.length > 0 && this.actualUserIsClient" class="listHeader">
				<b-row class="actor-tittle"> {{ this.$t("commons.binded") }} </b-row>
			</b-col>
			<b-form-tags
				v-model="this.supplierParentEntails"
				v-if="this.selectedSupplierParent > 0 && this.actualUserIsClient"
				no-outer-focus
				class="mb-2"
			>
				<template v-slot="{ tags, tagVariant }">
					<div class="d-inline-block" style="font-size: 1.5rem">
						<b-form-tag
							class="style-tags"
							v-for="tag in tags"
							:key="tag"
							:title="tag"
							:variant="tagVariant"
							:disabled="true"
							>{{ tag }}</b-form-tag
						>
					</div>
				</template>
			</b-form-tags>
			<b-col>
				<b-form-group>
					<div v-if="selectedSupplierParent > 0 && actualUserIsClient">
						<div class="row">
							<div class="col">
								<i18n path="pages.newInviteSupplier.sendEmailConfirmation" for="supplierParentEmail">
									<strong>{{ this.supplierParentEmail }}</strong>
								</i18n>
							</div>
						</div>
						<div class="row">
							<div class="col">
								<div class="custom-control custom-switch">
									<input
										type="checkbox"
										class="custom-control-input"
										id="supplierParentEmail"
										v-model="supplierParentEmailSwitch"
										:disabled="this.screenType != this.$inviteTabsType.inviteCreation"
									/>
									<label class="custom-control-label" for="supplierParentEmail"></label>
								</div>
							</div>
						</div>
					</div>
				</b-form-group>
			</b-col>
		</div>
		<div v-show="currentStep == 6" class="screenMargin tableAdjustment">
			<p class="stepName" style="padding-left: 0px">{{ $t("commons.generalRequirements") }}</p>
			<k-list-actions
				v-if="generalRequirementList.length"
				:fields="generalRequirementsFields"
				:items="generalRequirementList"
				@actionEdit="editRequirement"
				@actionView="viewRequirement"
				isSimpleCRUD
			>
				<template v-if="screenType == $inviteTabsType.inviteProcess" #cell(status)="generalRequirementList">
					<div class="d-flex align-items-center">
						<b-icon
							width="8"
							height="8"
							icon="circle-fill"
							:variant="generalRequirementList.item.data.statusVariant"
						></b-icon>
						<div class="ml-2">{{ generalRequirementList.item.data.status }}</div>
					</div>
				</template>
			</k-list-actions>
			<k-info-box
				v-if="generalRequirementList.length <= 0"
				type="success"
				:closeButton="false"
				:info="infoBoxObj"
				id="infoBox"
			/>
		</div>
		<div v-show="currentStep == 7" class="screenMargin tableAdjustment">
			<p class="stepName" style="padding-left: 0px">{{ $t("commons.specificRequirements") }}</p>
			<k-list-actions
				v-if="specificRequirementList.length > 0"
				:fields="requirementFields"
				:items="specificRequirementList"
				@actionEdit="editRequirement"
				@actionView="viewRequirement"
				isSimpleCRUD
			>
				<template v-if="screenType == $inviteTabsType.inviteProcess" #cell(status)="specificRequirementList">
					<div class="d-flex align-items-center">
						<b-icon
							width="8"
							height="8"
							icon="circle-fill"
							:variant="specificRequirementList.item.data.statusVariant"
						></b-icon>
						<div class="ml-2">{{ specificRequirementList.item.data.status }}</div>
					</div>
				</template>
			</k-list-actions>
			<k-info-box
				v-if="specificRequirementList.length <= 0"
				type="success"
				:closeButton="false"
				:info="infoBoxObj"
				id="infoBox"
			/>
			<b-col cols="12" v-show="actorList.length > 0 && this.actualUserIsClient" class="listHeader">
				<b-row class="actor-tittle">{{ $t("commons.actors") }}</b-row>
			</b-col>
			<b-form-tags
				v-model="actorList"
				v-if="actorList.length > 0 && this.actualUserIsClient"
				no-outer-focus
				class="mb-2"
			>
				<template v-slot="{ tags, tagVariant }">
					<div class="d-inline-block" style="font-size: 1.5rem">
						<b-form-tag
							class="style-tags"
							v-for="tag in tags"
							:key="tag"
							:title="tag"
							:variant="tagVariant"
							:disabled="true"
							>{{ tag }}</b-form-tag
						>
					</div>
				</template>
			</b-form-tags>

			<response-requirement-modal
				ref="ResponseRequirementModal"
				:modalType="modalType"
				@closeModal="loadList"
				@saveAnswer="handleTableAnswer"
				@refreshRegistrationData="handleRegistrationDataRefresh"
			/>
			<data-table-component
				ref="dataTableComponent"
				:modalType="modalType"
				@closeModal="loadList"
				@saveAnswer="handleTableAnswer"
			/>
		</div>
		<div
			v-if="screenType == $inviteTabsType.inviteProcess"
			v-show="currentStep == 8"
			class="screenMargin tableAdjustment"
		>
			<FollowUpTab
				ref="followUpTabComponent"
				:inviteId="idInvite"
				:screenType="screenType"
				@showDetails="showStepDetails"
				class="w-100"
			/>
		</div>

		<div class="screenMargin btnRow">
			<!--Actions-->
			<template v-if="screenType == $inviteTabsType.inviteProcess">
				<b-button
					:variant="action.buttonColor || 'info'"
					class="float-right ml-2 btnMarginAdjustment"
					v-for="action in availableActions"
					:id="action.idStep"
					:key="action.idStep"
					@click="openNextStepModal(action)"
				>
					{{ action.nomeAcao }}
				</b-button>
			</template>
			<k-button
				text="Salvar"
				v-if="canShowSaveButton()"
				id="salveBtn"
				variant="info"
				@click="saveRegistrationData({ showAlert: true })"
				class="float-right ml-2 btnMarginAdjustment"
			/>
			<k-button
				text="Salvar"
				v-if="canShowBankSaveButton()"
				id="salveBankBtn"
				variant="info"
				@click="saveBankData({ showAlert: true })"
				class="float-right ml-2 btnMarginAdjustment"
			/>
			<k-button
				:text="$t('buttons.startInvite')"
				:disabled="!userPermissions.create || loading"
				v-if="screenType != $inviteTabsType.inviteProcess"
				id="saveChangesBtn"
				variant="info"
				@click="() => createInvite(false)"
			/>
			<k-button
				:text="$t('buttons.cancel')"
				:disabled="!havePermission"
				v-if="screenType != $inviteTabsType.inviteProcess"
				id="cancelBtn"
				@click="cancelChanges"
			/>
			<k-button
				:text="$t('buttons.back')"
				:class="{ btnMarginAdjustment: currentStep != 4 }"
				v-if="screenType == $inviteTabsType.inviteProcess"
				id="cancelBtn"
				@click="back"
			/>
		</div>

		<invite-step-history-modal ref="InviteStepHistoryModal" />
		<workflow-history-message-modal
			ref="WorkflowHistoryMessageModal"
			@confirm="nextStepConfirm"
			@cancel="cancelNextStep"
		/>
		<k-modal
			ref="editEmailModal"
			id="editEmailModal"
			:title="$t('commons.modals.editEmail.title')"
			:okTitle="$t('buttons.update')"
			okVariant="info"
			:cancelTitle="$t('buttons.cancel')"
			cancelVariant="outline-info"
			size="md"
			@ok="callbackOk"
			@cancel="callbackCanceled"
			@hidden="hideModal"
			:message="modalEmailMsg"
		/>
		<k-modal
			:onOk="() => createInvite(true)"
			ref="confirmMessage"
			id="confirmMessage"
			:title="$t('commons.attention')"
			:okTitle="$t('buttons.binding')"
			:cancelTitle="$t('buttons.cancel')"
			okVariant="info"
			cancelVariant="outline-info"
			size="md"
			:message="
				$t('pages.newInviteSupplier.modals.confirmMessage.message', [
					this.supplierParentEmailSwitch ? this.supplierParentEmail : this.inviteDetails.email
				])
			"
		/>
		<k-modal
			id="inviteTabChangeModal"
			:title="$t('commons.attention')"
			okVariant="info"
			cancelVariant="outline-info"
			:okTitle="$t('buttons.save')"
			:cancelTitle="$t('buttons.undo')"
			size="402px"
			class="d-block"
			@cancel="discardCompaniesAndFamiliesChanges"
			:message="$t('pages.newInviteSupplier.modals.inviteTabChange.message')"
		/>
		<k-modal
			id="requesterCpfModal"
			:title="$t('commons.attention')"
			okVariant="info"
			cancelVariant="outline-info"
			:okTitle="$t('buttons.save')"
			:cancelTitle="$t('buttons.cancel')"
			size="402px"
			class="d-block"
			@ok="requesterModalOk"
			@cancel="requesterModalCancel"
		>
			<template v-slot:content>
				<k-crud ref="RequesterCpfKCrud" :fields="requesterStructure" :data="inviteDetails" :key="inviteDetailsKey" />
			</template>
		</k-modal>
	</div>
</template>

<script>
import { orderBy } from "lodash";
import { mapActions, mapGetters, mapMutations } from "vuex";
import ModalMixin from "@/mixins/ModalMixin";
import StepNavigationTitle from "../../components/ui/StepperComponents/StepNavigationTitle.vue";
import KCrud from "../../components/ui/KCrud.vue";
import KTreeView from "../../components/ui/KTreeView.vue";
import KFamilyTree from "../../components/ui/KFamilyTree.vue";
import KButton from "../../components/ui/Buttons/KButton.vue";
import Vue from "vue";
import KListActions from "../../components/ui/KListActions.vue";
import KListRadio from "../../components/ui/KListRadio.vue";
import ResponseRequirementModal from "../../components/modals/ResponseRequirementModal.vue";
import DataTableComponent from "../../components/ui/DataTableComponent.vue";
import KInfoBox from "../../components/ui/KInfoBox.vue";
import KModal from "../../components/modals/KModal.vue";
import WorkflowHistoryMessageModal from "../../components/modals/WorkflowHistoryMessageModal.vue";
//import KVerticalStepper from "../../components/ui/KVerticalStepper.vue";
import AutoComplete from "primevue/autocomplete";
import VMasker from "vanilla-masker";
import InputMask from "primevue/inputmask";
import FollowUpTab from "../../components/tabs/FollowUpTab.vue";
import InviteStepHistoryModal from "../../components/modals/InviteStepHistoryModal.vue";

export default {
	components: {
		StepNavigationTitle,
		KCrud,
		KTreeView,
		KFamilyTree,
		KButton,
		KListActions,
		KListRadio,
		ResponseRequirementModal,
		DataTableComponent,
		KInfoBox,
		KModal,
		WorkflowHistoryMessageModal,
		//KVerticalStepper,
		AutoComplete,
		InputMask,
		FollowUpTab,
		InviteStepHistoryModal
	},
	mixins: [ModalMixin],
	props: {
		screenType: {
			type: Number,
			require: true,
			default: 1 //inviteCreation
		},
		name: {
			type: String,
			require: true
		},
		idInvite: {
			type: [String, Number]
		},
		actualStepActor: {
			type: [Number]
		},
		idStep: {
			type: [Number, String],
			require: true
		},
		idClient: {
			type: [Number]
		}
	},
	data() {
		var checkEmail = null;
		let supplierDetailsHasData = false;
		let isRadioButtonDisabled = true;
		let supplierParentEmailSwitch = false;
		let supplierParentEmail = "";
		let requirementHasNoViewer = false;
		return {
			idSupplier: 0,
			standardListBanks: [],
			standardListAgencies: [],
			agenciesList: [],
			dataContact: {
				idContact: null,
				nameContact: "",
				sector: "",
				emailContact: "",
				phoneContact: "",
				cellphoneContact: ""
			},
			dataBank: {
				id: null,
				nameBank: "",
				agencyDescription: "",
				agencyDigit: null,
				idAgency: null,
				account: "",
				accountDigit: "",
				accountType: 1,
				bankDescription: "",
				idBank: null
			},
			hasTriedToAvanced: false,
			workflowSendsInvite: true,
			emailExist: false,
			validateFile: false,
			confirmNextStep: false,
			loading: false,
			fileName: null,
			duplicateSupplier: false,
			supplierDetailsHasData,
			isRadioButtonDisabled,
			supplierParentEmailSwitch,
			supplierParentEmail,
			requirementHasNoViewer,
			modalEmailMsg: this.$t("commons.modals.editEmail.message"),
			supplierDetails: {},
			supplierData: {},
			infoBoxSupplierParent: {
				message: this.$t("pages.newInviteSupplier.infoBox.supplierParent.message"),
				title: this.$t("messages.infoBox.noSupplier.title"),
				show: true
			},
			infoBoxObj: {
				title: this.$t("messages.infoBox.noRequirement.title"),
				show: true
			},
			infoBoxInvite: {
				title: this.$t("pages.newInviteSupplier.infoBox.inviteNotSendYet.title"),
				show: true
			},
			modalRequirementConfirmConfigs: {
				message: this.$t("pages.newInviteSupplier.modals.requirementConfirm.message"),
				title: this.$t("commons.attention"),
				okTitle: this.$t("commons.continue"),
				cancelTitle: this.$t("buttons.cancel")
			},
			crudKey: 0,
			type: "new",
			newInviteSupplierData,
			filter: {
				NameFilter: "",
				ItemCodeFilter: ""
			},
			supplierFilter: {
				nameFilter: "",
				cnpjCpfFilter: ""
			},
			appliedFilter: false,
			fields: [
				{
					key: "description",
					label: this.$t("commons.requirementName")
				}
			],
			fieldsReqs: [
				{
					key: "description",
					label: this.$t("commons.requirementName")
				},
				{
					key: "category",
					label: this.$t("commons.category")
				}
			],
			fieldsReqRes: [
				{
					key: "description",
					label: this.$t("commons.description")
				},
				{
					key: "type",
					label: this.$t("commons.type")
				},
				{
					key: "group",
					label: this.$t("commons.group")
				},
				{
					key: "status",
					label: this.$t("commons.status")
				}
			],
			checkEmail,
			validateHidden: false,
			selectedSupplierParent: 0,
			supplierParentEntails: [],
			selectedCompanies: [],
			oldSelectedCompanies: [],
			selectedFamilies: [],
			oldSelectedFamilies: [],
			companyOptions: [],
			currentStep: 1,
			actions: [],
			modalType: this.$requirementResponseModalType.anyView,
			stepsWorkflow: [],
			oldFamilies: [],
			oldCompanies: [],
			inviteDetailsKey: 0,
			supplierDetailsKey: 0,
			dataContactKey: 0,
			dataBankKey: 0,
			navigationKey: 0,
			companiesKey: 0,
			familiesKey: 0,
			emailSupplier: "",
			inviteRehomologation: false,
			maxLengthWithPontuation,
			inviteType: this.$InviteType.NORMAL_CREATION,
			enabledSupplierName: true,
			registrationDataSaved: false,
			userHasPermissionToEditRegistrationData: false,
			supplierCodeERP: null,
			inviteTabs: {
				InviteData: 1,
				RegistrationData: 2,
				ContactData: 3,
				Supplies: 4,
				Bond: 5,
				GeneralReq: 6,
				SpecificReq: 7,
				FollowUp: 8
			}
		};
	},
	computed: {
		...mapGetters([
			//Invite
			"inviteDetails",

			//Requirements
			"generalRequirements",
			"specificRequirements",
			"companyRequirement",
			"familyRequirement",

			//User
			"actualUser",

			//Actions
			"stepActions",

			//Workflow
			"workflowTypes",
			"stepFields",

			//Configurations
			"configurations",

			//Suppliers
			"suppliers",
			"supplierEntails",
			"supplierEmail",

			"ufs",
			"countries",
			"document",
			"companies",
			"families",
			"workflows",
			"familiesWithStatus",
			"listItensSelected",
			"requirementsByFamily",
			"actualOffer",
			"userPermissions",
			"actors",
			"requirements",
			"actualUserIsClient",
			"integration",
			"languages",

			//SupplierBank
			"standardListBank"
		]),
		mapLanguages() {
			if (this.languages.length) {
				let languageList = this.languages.map((lang) => {
					return { value: lang.idLanguage, text: lang.name };
				});
				this.mapDefaultLanguage();
				return languageList;
			}

			return [];
		},
		getFileName: function () {
			return this.fileName !== null ? this.fileName : null;
		},
		requirementFields: function () {
			let requirementFields = [
				{
					key: "codeERP",
					label: this.$t("commons.codeERP")
				},
				{
					key: "description",
					label: this.$t("commons.requirementName")
				}
			];
			if (this.screenType == this.$inviteTabsType.inviteProcess) {
				requirementFields.push(
					{
						key: "lastRequirementResponse",
						label: this.$t("commons.fill")
					},
					{
						key: "status",
						label: this.$t("commons.status")
					}
				);
			}
			return requirementFields;
		},
		generalRequirementsFields: function () {
			let generalRequirementsFields = [
				{
					key: "codeERP",
					label: this.$t("commons.codeERP")
				},
				{
					key: "description",
					label: this.$t("commons.description")
				}
			];
			if (this.screenType == this.$inviteTabsType.inviteProcess) {
				generalRequirementsFields.push(
					{
						key: "lastRequirementResponse",
						label: this.$t("commons.fill")
					},
					{
						key: "status",
						label: this.$t("commons.status"),
						tdClass: "text-right"
					}
				);
			}
			return generalRequirementsFields;
		},
		supplierParentFields: function () {
			let supplierParentFields = [
				{
					key: "supplierName",
					label: this.$t("commons.supplierClientName")
				},
				{
					key: "cnpjCpf",
					label: this.$t("commons.CpfCnpj")
				}
			];
			if (this.configurations?.MunicipalAndStateRegistration) {
				supplierParentFields.push(
					{
						key: "stateRegistration",
						label: this.$t("commons.stateInscription")
					},
					{
						key: "municipalRegistration",
						label: this.$t("commons.municipalInscription")
					}
				);
			}
			return supplierParentFields;
		},
		visibleSteps: function () {
			let navigationSteps = [];
			const hasSupplierParentStep =
				this.actualUserIsClient &&
				this.configurations.supplierParent &&
				(this.screenType === this.$inviteTabsType.inviteCreation || this.inviteDetails.supplierParent);

			if (this.supplierDetailsHasData) {
				navigationSteps.push({ id: 2, title: this.$t("pages.newInviteSupplier.steps.registrationData") });
			}

			if (hasSupplierParentStep) {
				navigationSteps.push({ id: 5, title: this.$t("commons.bind") });
			}

			let inviteCreation = this.screenType != this.$inviteTabsType.inviteProcess;

			if (this.generalRequirements.length > 0) {
				navigationSteps.push({
					id: 6,
					title: this.$t("commons.generalRequirements"),
					status: 6 == this.currentStep || inviteCreation ? undefined : this.getStepStatus(6)
				});
			}

			if (this.actualUserIsClient) {
				navigationSteps.push({ id: 1, title: this.$t("commons.invite") });
				if (!this.configurations.HideRelationshipTab || this.hasConfiguredBankField()) {
					navigationSteps.push({ id: 3, title: this.$t("commons.relationship") });
				}
				navigationSteps.push({ id: 4, title: this.$t("commons.supplies") });
				navigationSteps.push({
					id: 7,
					title: this.$t("commons.specificRequirements"),
					status: 7 == this.currentStep || inviteCreation ? undefined : this.getStepStatus(7)
				});
				navigationSteps.push({ id: 8, title: this.$t("pages.newInviteSupplier.steps.followUp") });
			} else {
				navigationSteps.push({
					id: 7,
					title: this.$t("commons.specificRequirements"),
					status: 7 == this.currentStep || inviteCreation ? undefined : this.getStepStatus(7)
				});
			}
			return orderBy(navigationSteps, ["id"], ["asc"]);
		},
		actorList: function () {
			let actors = [];

			this.specificRequirements.forEach((specificReq) => {
				if (actors.indexOf(specificReq.fillerActorName) == -1) actors.push(specificReq.fillerActorName);
				if (actors.indexOf(specificReq.validateActorName) == -1) actors.push(specificReq.validateActorName);
			});

			this.generalRequirements.forEach((generalReq) => {
				if (actors.indexOf(generalReq.fillerActorName) == -1) actors.push(generalReq.fillerActorName);
				if (actors.indexOf(generalReq.validateActorName) == -1) actors.push(generalReq.validateActorName);
			});

			return actors;
		},
		supplierDetailsStructure() {
			let countries = this.countries.map((country) => {
				return { value: country.nome, text: country.nome };
			});
			let uf = this.ufs.map((uf) => {
				return { value: uf.sigla, text: uf.sigla };
			});

			/*
			IMPORTANTE!
			O param "Name" de cada Field da structure é um reflexo da tabela InviteField
			Se for inserir ou precisar alterar o "Name" de algum field, é necessário inserir ou alterar na tabela InviteField
			*/
			let supplierCrudStructure = [];

			if (this.inviteDetails.personType === this.$PersonType.PJ) {
				if (this.supplierData.corporationName)
					supplierCrudStructure.push({
						rowNum: 1,
						width: "6",
						label: this.formatMandatoryLabel(
							this.$t("commons.corporationName"),
							"corporationName",
							this.inviteTabs.RegistrationData
						),
						type: "text",
						name: "corporationName",
						validation: this.isFieldValidationRequired("corporationName", this.inviteTabs.RegistrationData)
							? this.$validations.required
							: false,
						isActive: () => {
							return false;
						}
					});
				if (this.supplierData.supplierName)
					supplierCrudStructure.push({
						rowNum: 1,
						width: "6",
						label: this.formatMandatoryLabel(
							this.$t("commons.fantasyName"),
							"supplierName",
							this.inviteTabs.RegistrationData
						),
						type: "text",
						name: "supplierName",
						validation: this.isFieldValidationRequired("supplierName", this.inviteTabs.RegistrationData)
							? this.$validations.required
							: false,
						isActive: () => {
							return false;
						}
					});
			}

			supplierCrudStructure.push(
				{
					rowNum: 2,
					width: "6",
					label: this.formatMandatoryLabel(
						this.$t("commons.address.country"),
						"country",
						this.inviteTabs.RegistrationData
					),
					valueKey: "value",
					valueText: "text",
					type: "dropdown",
					name: "country",
					validation: this.isFieldValidationRequired("country", this.inviteTabs.RegistrationData)
						? this.$validations.required
						: false,
					returnKey: true,
					options: countries,
					isActive: () => {
						return this.canModifyStructureField("country", this.inviteTabs.RegistrationData);
					}
				},
				{
					rowNum: 2,
					width: "6",
					label: this.formatMandatoryLabel(
						this.$t("commons.address.zipCode"),
						"zipCode",
						this.inviteTabs.RegistrationData
					),
					type: "text",
					name: "zipCode",
					validation: this.isFieldValidationRequired("zipCode", this.inviteTabs.RegistrationData)
						? this.$validations.required
						: false,
					mask: this.supplierData?.country?.toLowerCase() === "brasil" ? "#####-###" : null,
					parentName: "country",
					maxlength: 10,
					isActive: () => {
						return this.canModifyStructureField("zipCode", this.inviteTabs.RegistrationData);
					}
				},
				{
					rowNum: 3,
					width: "6",
					label: this.formatMandatoryLabel(
						this.$t("commons.address.address"),
						"address",
						this.inviteTabs.RegistrationData
					),
					type: "text",
					name: "address",
					validation: this.isFieldValidationRequired("address", this.inviteTabs.RegistrationData)
						? this.$validations.required
						: false,
					maxlength: 60,
					isActive: () => {
						return this.canModifyStructureField("address", this.inviteTabs.RegistrationData);
					}
				},
				{
					rowNum: 3,
					width: "3",
					label: this.formatMandatoryLabel(
						this.$t("commons.address.number"),
						"number",
						this.inviteTabs.RegistrationData
					),
					type: "text",
					name: "number",
					validation: this.isFieldValidationRequired("number", this.inviteTabs.RegistrationData)
						? this.$validations.required
						: false,
					maxlength: 10,
					isActive: () => {
						return this.canModifyStructureField("number", this.inviteTabs.RegistrationData);
					}
				},
				{
					rowNum: 3,
					width: "3",
					label: this.formatMandatoryLabel(
						this.$t("commons.address.complement"),
						"complement",
						this.inviteTabs.RegistrationData
					),
					type: "text",
					name: "complement",
					validation: this.isFieldValidationRequired("complement", this.inviteTabs.RegistrationData)
						? this.$validations.required
						: false,
					maxlength: 10,
					isActive: () => {
						return this.canModifyStructureField("complement", this.inviteTabs.RegistrationData);
					}
				},
				{
					rowNum: 4,
					width: "5",
					label: this.formatMandatoryLabel(
						this.$t("commons.address.district"),
						"district",
						this.inviteTabs.RegistrationData
					),
					type: "text",
					name: "district",
					validation: this.isFieldValidationRequired("district", this.inviteTabs.RegistrationData)
						? this.$validations.required
						: false,
					maxlength: 40,
					isActive: () => {
						return this.canModifyStructureField("district", this.inviteTabs.RegistrationData);
					}
				},
				{
					rowNum: 4,
					width: "5",
					label: this.formatMandatoryLabel(this.$t("commons.address.city"), "city", this.inviteTabs.RegistrationData),
					type: "text",
					name: "city",
					validation: this.isFieldValidationRequired("city", this.inviteTabs.RegistrationData)
						? this.$validations.required
						: false,
					parentName: "country",
					maxlength: 40,
					isActive: () => {
						return this.canModifyStructureField("city", this.inviteTabs.RegistrationData);
					}
				}
			);

			if (this.supplierData.country?.toLowerCase() === "brasil") {
				supplierCrudStructure.push({
					rowNum: 4,
					width: "2",
					label: this.formatMandatoryLabel(this.$t("commons.address.state"), "uf", this.inviteTabs.RegistrationData),
					valueKey: "value",
					valueText: "text",
					type: "dropdown",
					name: "uf",
					validation: this.isFieldValidationRequired("uf", this.inviteTabs.RegistrationData)
						? this.$validations.required
						: false,
					returnKey: true,
					options: uf,
					placeholder: this.$t("commons.placeholders.selectState"),
					isActive: () => {
						return this.canModifyStructureField("uf", this.inviteTabs.RegistrationData);
					}
				});
			} else {
				supplierCrudStructure.push({
					rowNum: 4,
					width: "2",
					label: this.formatMandatoryLabel(this.$t("commons.address.state"), "uf", this.inviteTabs.RegistrationData),
					type: "text",
					name: "uf",
					validation: this.isFieldValidationRequired("uf", this.inviteTabs.RegistrationData)
						? this.$validations.required
						: false,
					parentName: "country",
					maxlength: 3,
					isActive: () => {
						return this.canModifyStructureField("uf", this.inviteTabs.RegistrationData);
					}
				});
			}

			return supplierCrudStructure;
		},
		inviteDetailsStructure: function () {
			const type = [
				{ value: 1, text: this.$t("commons.pessoaFisica") },
				{ value: 2, text: this.$t("commons.pessoaJuridica") }
			];

			const workflows = this.workflows.filter(
				(workflow) =>
					(workflow.isCustomer || workflow.isSupplier) &&
					(this.screenType !== this.$inviteTabsType.inviteCreation || workflow.ativo)
			);

			const uf = this.ufs.map((uf) => {
				return { value: uf.sigla, text: uf.sigla };
			});

			const countries = this.countries.map((country) => {
				return { value: country.nome, text: country.nome };
			});

			let inviteDetailsStructure = [
				{
					rowNum: 0,
					width: "6",
					label: this.$t("commons.address.country") + " *",
					valueKey: "value",
					valueText: "text",
					type: "dropdown",
					name: "country",
					returnKey: true,
					options: countries,
					validation: this.$validations.required,
					isActive: () => {
						return this.isInviteCreationWithoutRehomologation;
					}
				},
				{
					rowNum: 0,
					width: this.inviteDetails.personType == this.$PersonType.PF ? "3" : "6",
					label: this.$t("commons.address.state") + " *",
					valueKey: "value",
					valueText: "text",
					type: "dropdown",
					name: "uf",
					returnKey: true,
					options: uf,
					parentName: "personType",
					placeholder: this.$t("commons.placeholders.selectState"),
					isVisible: this.inviteDetails.country == "Brasil" ? true : false,
					validation: this.validateMandatoryStateField ? this.$validations.required : false,
					isActive: () => {
						return this.isInviteCreationWithoutRehomologation;
					}
				},
				{
					rowNum: 0,
					width: "3",
					label: this.validateMandatoryDateOfBirthField
						? this.$t("commons.dateOfBirth") + " *"
						: this.$t("commons.dateOfBirth"),
					type: "text",
					name: "birthDate",
					mask: "##/##/####",
					parentName: "personType",
					placeholder: this.$t("commons.placeholders.dayMonthYear"),
					isVisible:
						this.inviteDetails.personType == 1
							? this.inviteDetails.personType == 1 && this.inviteDetails.country == "Brasil"
								? true
								: false
							: false,
					validation: this.validateMandatoryDateOfBirthField
						? this.$validations.birthDateRequired
						: this.$validations.birthDateNotRequired,
					isActive: () => {
						return this.isInviteCreationWithoutRehomologation;
					}
				},
				{
					rowNum: 1,
					width: "6",
					type: "radio",
					name: "personType",
					label: this.$t("pages.newInviteSupplier.supplierClientType") + " *",
					radios: type,
					parentName: "country",
					isActive: (country) => {
						if (country == "Brasil") return this.isInviteCreationWithoutRehomologation;
						else if (country == null) return false;
						else return false;
					},
					isVisible: this.inviteDetails.country == "Brasil" ? true : false,
					validation: this.$validations.radioButton
				},
				{
					rowNum: 1,
					width: "6",
					label:
						this.inviteDetails.personType == this.$PersonType.PJ
							? this.$t("commons.cnpj") + " *"
							: this.$t("commons.cpf") + " *",
					type: "text",
					name: "cnpjCpf",
					mask: this.inviteDetails.personType == this.$PersonType.PJ ? "NN.NNN.NNN/NNNN-##" : "###.###.###-##",
					maxlength:
						this.inviteDetails.personType == this.$PersonType.PJ
							? this.maxLengthWithPontuation.CNPJ
							: this.maxLengthWithPontuation.CPF,
					parentName: "personType",
					placeholder: this.inviteDetails.personType == 2 ? this.$t("commons.cnpj") : this.$t("commons.cpf"),
					isVisible: this.inviteDetails.country == "Brasil" ? true : false,
					validation:
						this.inviteDetails.personType != null && this.inviteDetails.country == "Brasil"
							? this.ValidateCnpjCpf()
							: null,
					isActive: () => {
						return this.isInviteCreationWithoutRehomologation;
					}
				},
				{
					rowNum: 0,
					width: "6",
					label: this.$t("commons.uniqueIdentifier") + "*",
					type: "text",
					name: "nif",
					parentName: "country",
					placeholder: this.$t("commons.uniqueIdentifierExample"),
					isVisible: this.inviteDetails.country && this.inviteDetails.country.toLowerCase() != "brasil",
					isActive: () => {
						return this.isInviteCreationWithoutRehomologation;
					}
				},
				{
					rowNum: 2,
					width: "6",
					label: this.$t("commons.stateInscription"),
					type: "text",
					name: "stateRegistration",
					placeholder: this.$t("commons.stateInscription"),
					isVisible: this.configurations.MunicipalAndStateRegistration && this.inviteDetails.country == "Brasil",
					maxlength: 13,
					mask: "#############",
					isActive: () => {
						return this.isInviteCreationWithoutRehomologation;
					}
				},
				{
					rowNum: 2,
					width: "6",
					label: this.$t("commons.municipalInscription"),
					type: "text",
					name: "municipalRegistration",
					placeholder: this.$t("commons.municipalInscription"),
					isVisible: this.configurations.MunicipalAndStateRegistration && this.inviteDetails.country == "Brasil",
					maxlength: 15,
					mask: "###############",
					isActive: () => {
						return this.isInviteCreationWithoutRehomologation;
					}
				},
				{
					rowNum: 3,
					width: "12",
					label: this.validateMandatorySupplierNameField
						? this.$t("commons.supplierClientName")
						: this.$t("commons.supplierClientName") + " *",
					type: "text",
					name: "supplierName",
					placeholder: this.$t("commons.supplierClientName"),
					validation: !this.validateMandatorySupplierNameField ? this.$validations.required : false,
					isActive: () => {
						return this.isInviteCreationWithoutRehomologation;
					}
				},
				{
					rowNum: 4,
					width: "6",
					label: this.$t("commons.workflowType") + " *",
					type: "dropdown",
					name: "flowType",
					returnKey: true,
					options: this.workflowTypeOption,
					placeholder: this.$t("commons.placeholders.selectWorkflowType"),
					validation: this.$validations.required,
					isActive: () => {
						return this.screenType == this.$inviteTabsType.inviteCreation;
					}
				},
				{
					rowNum: 4,
					width: "6",
					type: "dropdown",
					valueKey: "id",
					valueText: "nome",
					name: "idWorkflow",
					label: this.$t("commons.workflow") + " *",
					placeholder: this.$t("commons.placeholders.selectWorkflow"),
					returnKey: true,
					options: workflows,
					validation: this.$validations.required,
					isActive: () => {
						return this.screenType == this.$inviteTabsType.inviteCreation;
					}
				},
				{
					rowNum: 5,
					width: "6",
					label: this.workflowSendsInvite
						? this.$t("commons.registrationEmail") + " *"
						: this.$t("commons.registrationEmail"),
					type: "text",
					name: "email",
					placeholder: this.$t("commons.email"),
					validation: this.workflowSendsInvite ? this.$validations.email : null,
					isActive: () => {
						return this.isInviteCreationWithoutRehomologation;
					}
				},
				{
					rowNum: 5,
					width: "6",
					label: this.workflowSendsInvite
						? this.$t("pages.newInviteSupplier.emailToInvite") + " *"
						: this.$t("pages.newInviteSupplier.emailToInvite"),
					type: "text",
					name: "inviteEmail",
					placeholder: this.$t("commons.email"),
					validation: this.workflowSendsInvite ? this.$validations.email : null,
					isActive: () => {
						return this.screenType == this.$inviteTabsType.inviteCreation;
					}
				},
				{
					rowNum: 6,
					width: "6",
					label: this.$t("pages.newInviteSupplier.messageObservation"),
					type: "text",
					name: "message",
					placeholder: "",
					isActive: () => {
						return this.screenType == this.$inviteTabsType.inviteCreation;
					}
				},
				{
					rowNum: 6,
					width: "6",
					label: `${this.$t("pages.newInviteSupplier.sendCopyEmail")}`,
					type: "checkbox",
					name: "sendCopyInviteEmail",
					isVisible: this.configurations.SendCopyInviteEmail,
					isActive: () => {
						return this.workflowSendsInvite && this.screenType == this.$inviteTabsType.inviteCreation;
					}
				},
				{
					rowNum: 6,
					width: "6",
					label: this.$t("commons.attachment"),
					type: "customField",
					isActive: () => {
						return this.screenType == this.$inviteTabsType.inviteCreation;
					}
				},
				{
					rowNum: 7,
					width: "6",
					label: `${this.$t("pages.newInviteSupplier.sendAttachmentEmail")}`,
					type: "checkbox",
					name: "sendAttachmentEmailInvitation",
					isActive: () => {
						return this.screenType == this.$inviteTabsType.inviteCreation;
					}
				},
				{
					rowNum: 7,
					width: "6"
				},
				{
					rowNum: 8,
					width: "2",
					label: this.$t("pages.newInviteSupplier.inviteLanguage"),
					type: "dropdown",
					valueKey: "value",
					valueText: "text",
					name: "inviteLanguageId",
					returnKey: true,
					options: this.mapLanguages,
					isVisible: this.languages.length > 1,
					validation: this.languages.length > 1 ? this.$validations.required : false,
					isActive: () => {
						return this.screenType == this.$inviteTabsType.inviteCreation;
					}
				}
			];

			return inviteDetailsStructure;
		},
		requesterStructure: function () {
			let requesterStructure = [
				{
					rowNum: 0,
					width: "12",
					label: this.$t("pages.newInviteSupplier.requesterCPF") + " *",
					type: "text",
					name: "requesterCPF",
					mask: "###.###.###-##",
					placeholder: this.$t("commons.cpf"),
					validation: this.$validations.cpf
				}
			];
			return requesterStructure;
		},
		familiesHaveChanges: function () {
			return this.oldSelectedFamilies.join() != this.selectedFamilies.join();
		},
		companiesHaveChanges: function () {
			return this.oldSelectedCompanies.join() != this.selectedCompanies.join();
		},
		canRequestNextStep: function () {
			// TODO @rafael.silva existe necessidade de habilitar os botões apenas quando todos os requisitos estiverem ok?
			return true;
		},
		editCompaniesPermission: function () {
			if (this.screenType == this.$inviteTabsType.inviteCreation && this.inviteRehomologation) return false;
			if (this.screenType != this.$inviteTabsType.inviteProcess) return true;

			if (
				(this.actualUser.actorList.indexOf(this.companyRequirement[0]?.idValidateActor) != -1 ||
					this.actualUser.actorList.indexOf(this.companyRequirement[0]?.idFillerActor) != -1) &&
				this.actualStepActor == this.companyRequirement[0]?.idFillerActor
			)
				return true;

			return false;
		},
		editFamiliesPermission: function () {
			if (this.screenType != this.$inviteTabsType.inviteProcess) return true;
			if (
				(this.actualUser.actorList.indexOf(this.familyRequirement[0]?.idValidateActor) != -1 ||
					this.actualUser.actorList.indexOf(this.familyRequirement[0]?.idFillerActor) != -1) &&
				this.actualStepActor == this.familyRequirement[0]?.idFillerActor
			)
				return true;

			return false;
		},
		validateOk: function () {
			if (this.requirementsByFamily.length === 0) return false;
			let ok = true;
			let _this = this;
			for (let index = 0; index < this.inviteSupplierCrudStructure.length; index++) {
				const field = this.inviteSupplierCrudStructure[index];
				if (field.validation) {
					ok = field.validation.rule(_this.newInviteSupplierData[field.name]);
					if (!ok) {
						break;
					}
				}
			}
			return ok;
		},
		blockCEPandStateField: function () {
			if (this.newInviteSupplierData.zipCode == null) return true;
			else return false;
		},
		companyList: function () {
			let companies = this.companies.map((s) => {
				return { value: s.idCompany, text: s.companyName };
			});
			return companies;
		},
		filterStructure: function () {
			let structure = [
				{
					rowNum: 0,
					width: "6",
					type: "text",
					label: this.$t("commons.filter.itemName"),
					placeholder: this.$t("commons.filter.itemName"),
					name: "NameFilter"
				},
				{
					rowNum: 0,
					width: "6",
					type: "text",
					label: this.$t("commons.filter.itemCode"),
					placeholder: this.$t("commons.filter.itemCode"),
					name: "ItemCodeFilter"
				}
			];
			return structure;
		},
		supplierFilterStructure: function () {
			let structure = [
				{
					rowNum: 0,
					width: "6",
					type: "text",
					label: this.$t("commons.supplierClientName"),
					placeholder: this.$t("commons.supplierClientName"),
					name: "nameFilter"
				},
				{
					rowNum: 0,
					width: "6",
					type: "text",
					label: this.$t("commons.CpfCnpj"),
					placeholder: this.$t("commons.CpfCnpj"),
					name: "cnpjCpfFilter"
				}
			];
			return structure;
		},
		havePermission: function () {
			return this.id ? this.userPermissions.update : this.userPermissions.create;
		},
		workflowTypeOption: function () {
			let workflowTypeOptions = this.workflowTypes.map((workflowType) => ({
				value: workflowType.id,
				text: workflowType.description
			}));
			return workflowTypeOptions;
		},
		workflowTypeOrientationMessage: function () {
			var message = "";
			if (this.inviteDetails.flowType) {
				let selectedWorkflowType = this.workflowTypes.find((wt) => wt.id == this.inviteDetails.flowType);
				if (selectedWorkflowType) {
					message = selectedWorkflowType.orientationMessage;
				}
			}
			return message;
		},
		offerId: function () {
			return this.$route.query.idOffer;
		},
		supplierId: function () {
			return this.$route.query.idSupplier;
		},
		specificRequirementList: function () {
			if (!this.specificRequirements) {
				return [];
			}

			const orderedRequirements = this.specificRequirements.map((req) => {
				const userStep = this.actualUser.actorList.includes(parseInt(this.actualStepActor));
				const isActualStepActorValid =
					[...(Array.isArray(req.idValidateActorList) ? req.idValidateActorList : []), req.idFillerActor].includes(
						parseInt(this.actualStepActor)
					) && userStep;
				const doesUserHaveActor = this.actualUser.actorList.includes(parseInt(this.actualStepActor));
				const isValidateActor = req.idValidateActorList?.includes(this.actualStepActor);
				const requirementStatus = this.mapBackStatusToFrontStatus(req.status);
				const isStatusApprovedOrRejected = [
					this.$RequirementStatus.Accepted,
					this.$RequirementStatus.Rejected
				].includes(req.status);
				const canActOnRequirement = isActualStepActorValid && doesUserHaveActor;
				const isFillerActWithStatus =
					this.actualStepActor == req.idFillerActor && req.status < this.$RequirementStatus.InProgress;
				const isNotActualFiller = this.actualStepActor != req.idFillerActor;
				const isStatusAbovePending = [
					this.$RequirementStatus.InProgress,
					this.$RequirementStatus.PartialAnswer,
					this.$RequirementStatus.Accepted,
					this.$RequirementStatus.Done,
					this.$RequirementStatus.Rejected,
					this.$RequirementStatus.InReevaluation,
					this.$RequirementStatus.Expired
				].includes(req.status);
				const isStatusUnderInProgress = [0, this.$RequirementStatus.Pending].includes(req.status);
				const isFillerValidatorOnReevaluation = this.processFillerOrValidatorOnReevaluation(req);

				const actions = {
					edit:
						req.canView &&
						((canActOnRequirement && !isValidateActor && !isStatusApprovedOrRejected) ||
							(canActOnRequirement && isFillerActWithStatus) ||
							isFillerValidatorOnReevaluation),
					view:
						req.canView &&
						(this.screenType == this.$inviteTabsType.inviteCreation ||
							(!canActOnRequirement && isNotActualFiller) ||
							(isStatusApprovedOrRejected && canActOnRequirement && !isValidateActor) ||
							(isNotActualFiller && !isValidateActor) ||
							(isValidateActor && isStatusUnderInProgress) ||
							(!isStatusUnderInProgress && !isValidateActor)),
					validate:
						req.canView &&
						isValidateActor &&
						!isFillerValidatorOnReevaluation &&
						(isStatusAbovePending || (isStatusUnderInProgress && !req.isMandatory))
				};

				return {
					codeERP: req.codeERP,
					idRequirement: req.idRequirement,
					description: req.description,
					lastRequirementResponse: req.lastRequirementResponse
						? this.$functions.formatDate(req.lastRequirementResponse)
						: "",
					group: req.groupDescription,
					reprocess: req.integrationNetrinError,
					type: req.isMandatory ? this.$t("commons.mandatory") : this.$t("commons.notMandatory"),
					netrinError: req.integrationMessageError,
					idStatus: req.status,
					status: requirementStatus.statusDescription,
					statusVariant: requirementStatus.statusVariant,
					actions: actions,
					ordenation: req.ordenation,
					displayType: req.displayType
				};
			});

			return this.sortRequirements(orderedRequirements);
		},
		generalRequirementList: function () {
			const orderedRequirements = this.generalRequirements.map((generalReq) => {
				//Verificar se o requisito é para ser atuado nessa etapa
				const actualStepIdActor = parseInt(this.actualStepActor);
				const requirementStep = this.verifyRequirementActedInStep(actualStepIdActor, generalReq);

				//Verificar se o usuário tem o ator responsável por essa etapa
				const userStep = this.actualUser.actorList.indexOf(actualStepIdActor) != -1;
				const IsValidateActor = generalReq.idValidateActorList?.includes(actualStepIdActor);

				const requirementStatus = this.mapBackStatusToFrontStatus(generalReq.status);
				const statusUnderInProgress = generalReq.status == this.$RequirementStatus.Pending || generalReq.status == 0;
				const isApprovedOrReprovedReq =
					requirementStatus == this.$RequirementStatus.Accepted ||
					requirementStatus == this.$RequirementStatus.Rejected;
				//A permissão para atuar no requisito
				const actPermission = requirementStep && userStep;
				const fillerActWithStatus = this.actualStepActor == generalReq.idFillerActor && statusUnderInProgress;
				const notActualFiller = this.actualStepActor != generalReq.idFillerActor;
				const isFillerValidatorOnReevaluation = this.processFillerOrValidatorOnReevaluation(generalReq);

				const statusAbovePending =
					generalReq.status == this.$RequirementStatus.InProgress ||
					generalReq.status == this.$RequirementStatus.PartialAnswer ||
					generalReq.status == this.$RequirementStatus.Accepted ||
					generalReq.status == this.$RequirementStatus.Done ||
					generalReq.status == this.$RequirementStatus.Rejected ||
					generalReq.status == this.$RequirementStatus.InReevaluation ||
					generalReq.status == this.$RequirementStatus.Expired;
				const statusBeforePending = generalReq.status == 0;

				const actions = {
					edit:
						generalReq.canView &&
						actPermission &&
						((!IsValidateActor && !isApprovedOrReprovedReq) || fillerActWithStatus || isFillerValidatorOnReevaluation),
					view:
						generalReq.canView &&
						(this.screenType === this.$inviteTabsType.inviteCreation
							? false
							: (!actPermission && notActualFiller) ||
							  (isApprovedOrReprovedReq && actPermission && !IsValidateActor) ||
							  (IsValidateActor && statusBeforePending) ||
							  (!statusUnderInProgress && !IsValidateActor)),
					validate: generalReq.canView && IsValidateActor && statusAbovePending
				};
				return {
					codeERP: generalReq.codeERP,
					idRequirement: generalReq.idRequirement,
					description: generalReq.description,
					lastRequirementResponse: generalReq.lastRequirementResponse
						? this.$functions.formatDate(generalReq.lastRequirementResponse)
						: "",
					group: generalReq.description,
					reprocess: generalReq.integrationNetrinError,
					type: generalReq.isMandatory ? this.$t("commons.mandatory") : this.$t("commons.notMandatory"),
					netrinError: generalReq.integrationMessageError,
					idStatus: generalReq.status,
					status: this.mapBackStatusToFrontStatus(generalReq.status).statusDescription,
					statusVariant: this.mapBackStatusToFrontStatus(generalReq.status).statusVariant,
					actions: actions,
					displayType: generalReq.displayType
				};
			});

			return this.sortRequirements(orderedRequirements);
		},
		availableActions() {
			let hasReavaluationRequirement = this.requirements.some(
				(req) => req.status == this.$RequirementStatus.InReevaluation
			);
			if (hasReavaluationRequirement) {
				return this.stepActions.filter((action) => action.destinationStepActorIsExternal);
			}
			return this.stepActions;
		},
		setWorkflowType() {
			return this.workflowTypes.find((workflowType) => workflowType.isDefault).id;
		},
		hasGeneralRequirements() {
			return this.generalRequirements.length;
		},
		hasSpecificRequirements() {
			return this.specificRequirements.length;
		},
		validateMandatoryDateOfBirthField() {
			return (
				this.specificRequirements.some((requirement) => requirement.description === "Receita Federal - CPF") &&
				this.inviteDetails.personType == 1 &&
				this.inviteDetails.country == "Brasil"
			);
		},
		validateMandatoryStateField() {
			return (
				(this.specificRequirements.some((requirement) => requirement.isIntegration) ||
					this.inviteDetails.personType == this.$PersonType.PJ) &&
				this.inviteDetails.country == "Brasil"
			);
		},
		validateMandatorySupplierNameField() {
			return this.inviteDetails.country == "Brasil" && this.configurations.OverwriteSupplierClientName;
		},
		contactStructure() {
			let contactStructure = [
				{
					rowNum: 0,
					width: "6",
					type: "text",
					label: this.$t("commons.contact.name"),
					name: "nameContact",
					isActive: () => {
						return this.screenType == this.$inviteTabsType.inviteCreation;
					}
				},
				{
					rowNum: 0,
					width: "6",
					type: "text",
					label: this.$t("commons.sector"),
					name: "sector",
					isActive: () => {
						return this.screenType == this.$inviteTabsType.inviteCreation;
					}
				},
				{
					rowNum: 1,
					width: "3",
					type: "text",
					label: this.$t("commons.phone"),
					placeholder: this.$t("commons.phone"),
					name: "phoneContact",
					placeholder: "(99) 9999-9999",
					customMask: "(99) 9999-9999",
					isActive: () => {
						return this.screenType == this.$inviteTabsType.inviteCreation;
					}
				},
				{
					rowNum: 1,
					width: "3",
					type: "text",
					label: this.$t("commons.cellphone"),
					name: "cellphoneContact",
					placeholder: "(99) 99999-9999",
					customMask: "(99) 99999-9999",
					isActive: () => {
						return this.screenType == this.$inviteTabsType.inviteCreation;
					}
				},
				{
					rowNum: 1,
					width: "6",
					type: "text",
					label: this.$t("commons.email"),
					name: "emailContact",
					validation: this.$validations.email,
					isActive: () => {
						return this.screenType == this.$inviteTabsType.inviteCreation;
					}
				}
			];
			return contactStructure;
		},
		bankStructure: function () {
			let bankStructure = [
				{
					rowNum: 0,
					width: "6",
					type: "text",
					label: this.$t("commons.fullName"),
					name: "name"
				},
				{
					rowNum: 0,
					width: "6",
					type: "text",
					label: this.$t("commons.bank"),
					name: "bank"
				},
				{
					rowNum: 1,
					width: "4",
					type: "text",
					label: this.$t("commons.agency"),
					name: "agency"
				},
				{
					rowNum: 1,
					width: "2",
					type: "text",
					label: this.$t("commons.accountWithDigit"),
					name: "account"
				},
				{
					rowNum: 1,
					width: "5",
					label: this.$t("commons.accountType"),
					type: "radio",
					name: "accountType",
					radios: [
						{ value: 1, text: this.$t("commons.currentAccount") },
						{ value: 2, text: this.$t("commons.savingsAccount") }
					],
					validation: this.$validations.radioButton
				}
			];
			return bankStructure;
		},
		structureRowOne: function () {
			return [
				{
					rowNum: 0,
					width: "12",
					label: this.bankFieldLabel("name", this.$t("commons.nameBank")),
					placeholder: this.$t("commons.nameBank"),
					type: "text",
					name: "nameBank",
					maxlength: 100,
					validation: this.isBankFieldValidationRequired("name") ? this.$validations.required : false,
					isActive: () => {
						return this.isBankFieldEditable("name");
					}
				}
			];
		},
		structureRowTwo: function () {
			return [
				{
					rowNum: 0,
					width: "8",
					label: this.bankFieldLabel("account", this.$t("commons.bankAccountNumber")),
					type: "text",
					name: "account",
					maxlength: 20,
					validation: this.isBankFieldValidationRequired("account") ? this.$validations.required : false,
					mask: "####################",
					isActive: () => {
						return this.isBankFieldEditable("account");
					}
				},
				{
					rowNum: 0,
					width: "4",
					label: this.bankFieldLabel("account", this.$t("commons.bankAccountDigit")),
					type: "text",
					name: "accountDigit",
					validation: this.isBankFieldValidationRequired("account") ? this.$validations.required : false,
					maxlength: 2,
					placeholder: "**",
					isActive: () => {
						return this.isBankFieldEditable("account");
					}
				},
				{
					rowNum: 1,
					width: "12",
					label: this.bankFieldLabel("accountType", this.$t("commons.accountType")),
					class: "mr-6",
					type: "radio",
					name: "accountType",
					radios: [
						{ value: 1, text: this.$t("commons.currentAccount") },
						{ value: 2, text: this.$t("commons.savingsAccount") }
					],
					validation: this.$validations.radioButton,
					isActive: () => {
						return this.isBankFieldEditable("accountType");
					}
				}
			];
		},
		isInviteCreationWithoutRehomologation() {
			return this.screenType == this.$inviteTabsType.inviteCreation && !this.inviteRehomologation;
		},
		isSelectAllChecked() {
			return this.companyOptions.every((group) => group.selected && group.children.every((child) => child.selected));
		}
	},
	methods: {
		...mapActions([
			//Requirements
			"getRequirementListByIdInvite",
			"getGeneralRequirements",
			"reprocessIntegration",
			"getRequirementsByIdFamily",
			"fetchErpIntegrationRequirements",
			"getAllRequirementQuestionListByClient",
			"getAllRequirementActors",

			//Families
			"getFamilies",
			"getFamilyChildrens",
			"addInviteChildrenOnSelectedList",
			"deleteParentsOnSelectedList",
			"deleteInviteChildrenOnSelectedList",

			//Workflow
			"getWorkflows",
			"getWorkflowDetails",
			"getAllWorkflowType",
			"getStepFields",

			//Companies
			"getCompaniesByGroupAndIdInvite",

			//Configurations
			"getConfigurationByClient",

			//User
			"checkUserEmailExistance",
			"getUserById",
			"getUserPermissionList",

			//Supplier
			"getSupplierData",
			"getSuppliers",
			"getSupplier",
			"getActors",
			"getIntegrationById",
			"getFilteredSuppliers",
			"getSupplierEntails",
			"getSupplierParent",
			"clearIntegration",
			"updateSupplierClientAddressStatus",
			"updateSupplierClientBankStatus",
			"getSupplierDetails",

			//SupplierBank
			"getStandardListValue",
			"getStandardListValueByType",

			//Address
			"getUfsNoAuth",
			"getCountriesNoAuth",

			//Invite
			"getInvite",
			"getOffer",
			"updateOfferStatus",
			"getSupplierEmailConfiguration",
			"getFullTreeListByIdFamily",
			"supplierUpdateEmail",
			"createSupplierEmail",
			"updateRequirementsResponseWorkflow",
			"nextStepWorkflow",
			"createInviteSupplier",
			"cancelInvite",

			//Document
			"uploadInviteDocument",
			"getInviteDocument",
			"downloadInviteDocument",

			//BlackList
			"getCheckBlackListed",
			"removeBlackListedSupplier",

			//Re-homologação
			"getSupplierDetailsForRehomologation",

			//History
			"getWorkflowHistoryDetailsByStep"
		]),
		...mapMutations([
			//Families
			"setListItensSelectedOnState",
			"setStatusOnTree",
			"setFlowTypeOnState",
			"setSelectedCompaniesOnState",
			"cleanRequirementsByFamily",
			"cleanInvite",
			"cleanIntegration",
			"setSpecificRequirementsOnState",
			"cleanSpecificRequirements",
			"cleanGeneralRequirements",
			"cleanStepActionsOnState",
			"setFamiliesOnState",

			//SupplierBank
			"setStandardListBankOnState"
		]),
		cancelNextStep() {
			this.registrationDataSaved = false;
		},
		canModifyRegistrationData() {
			return (
				this.userHasPermissionToEditRegistrationData &&
				this.inviteDetails.status !== this.$inviteStatus.COMPLETED &&
				this.inviteDetails.status !== this.$inviteStatus.CANCELED &&
				this.availableActions.length != 0
			);
		},
		canShowSaveButton() {
			return (
				this.screenType == this.$inviteTabsType.inviteProcess &&
				this.currentStep === 2 &&
				this.canModifyRegistrationData()
			);
		},
		canModifyStructureField(field, tab) {
			const canModify = this.canModifyRegistrationData();
			if (canModify) {
				const fieldRules = this.getFieldStructureRules(field, tab);
				return fieldRules?.visualizationType != this.$StepFieldVisualizationType.DISABLED;
			}

			return canModify;
		},
		isBankProcess() {
			return this.screenType == this.$inviteTabsType.inviteProcess;
		},
		isBankCreationMandatory() {
			return !this.configurations.HideRelationshipTab && this.configurations.DataBankObrigatority;
		},
		isBankFieldValidationRequired(fieldName) {
			if (fieldName === "agency" && !this.isBankFieldEditable("agency")) return false;
			return this.isBankProcess()
				? this.isFieldValidationRequired(fieldName, this.$InviteFieldTab.BANK_DATA)
				: this.isBankCreationMandatory();
		},
		isBankFieldRequiredLabel(fieldName) {
			if (fieldName === "agency" && !this.isBankFieldEditable("agency")) return false;
			return this.isBankProcess()
				? this.isFieldValidationRequired(fieldName, this.$InviteFieldTab.BANK_DATA, true)
				: this.isBankCreationMandatory();
		},
		bankFieldLabel(fieldName, label) {
			return this.isBankFieldRequiredLabel(fieldName) ? `${label}: *` : `${label}:`;
		},
		isBankFieldEditable(fieldName) {
			if (fieldName === "agency" && !this.isBankFieldEditable("bank")) return false;
			return this.isBankProcess()
				? this.canModifyStructureField(fieldName, this.$InviteFieldTab.BANK_DATA)
				: this.screenType == this.$inviteTabsType.inviteCreation;
		},
		isAnyBankFieldEditable() {
			return ["name", "bank", "agency", "account", "accountType"].some((field) => this.isBankFieldEditable(field));
		},
		hasConfiguredBankField() {
			return ["name", "bank", "agency", "account", "accountType"].some((field) => {
				const rules = this.getFieldStructureRules(field, this.$InviteFieldTab.BANK_DATA);
				return rules && rules.visualizationType !== this.$StepFieldVisualizationType.DISABLED;
			});
		},
		canShowBankSaveButton() {
			return (
				this.screenType == this.$inviteTabsType.inviteProcess &&
				this.currentStep === 3 &&
				this.canModifyRegistrationData()
			);
		},
		async saveBankData({ showAlert }) {
			if (!this.validateBankRequiredFields()) {
				this.$functions.displayError(this, this.$t("pages.newInviteSupplier.warning.mandatoryFillMandatoryFields"));
				this.currentStep = 3;
				this.loading = false;
				return;
			}

			const bankData = {
				idSupplier: this.inviteDetails.idSupplier,
				idClient: this.idClient,
				id: this.dataBank.id,
				name: this.dataBank.nameBank,
				idBank: this.dataBank.idBank,
				bank: this.dataBank.bankDescription?.description ?? this.dataBank.bankDescription,
				idAgency: this.dataBank.idAgency,
				agency: this.dataBank.agencyDescription?.description ?? this.dataBank.agencyDescription,
				agencyDigit: this.dataBank.agencyDigit,
				account: this.dataBank.account,
				accountDigit: this.dataBank.accountDigit,
				accountType:
					this.dataBank.accountType == 1 ? this.$t("commons.currentAccount") : this.$t("commons.savingsAccount")
			};

			try {
				const response = await this.updateSupplierClientBankStatus(bankData);
				if (response.isSuccess) {
					if (showAlert) this.$functions.displaySuccess(this, this.$t("messages.updatedSuccessfully"));
				} else {
					if (showAlert) this.$functions.displayError(this, this.$t("messages.changesCouldNotBeSaved"));
				}
				await this.getInvite({ idInvite: this.idInvite });
			} catch (e) {
				this.$functions.displayError(this, this.$t("messages.changesCouldNotBeSaved"));
				console.error(e);
			}
		},
		canEditRegistrationData() {
			return this.canModifyRegistrationData();
		},
		mapDefaultLanguage() {
			const languageDefault = this.languages.find((lang) => lang.isDefault) ?? this.languages[0];
			this.inviteDetails.inviteLanguageId = this.inviteDetails.inviteLanguageId ?? languageDefault.idLanguage;
		},
		fileChange: function (file) {
			if (file.target.files[0] != null) {
				let data = {
					file: file.target.files[0],
					idClient: this.actualUser.idClient
				};
				this.validateFile = this.$functions.validateFileProperties(data.file, this);
				if (this.validateFile) {
					this.uploadInviteDocument(data).then((fileInformations) => {
						this.fileName = data.file.name;
						this.inviteDetails.attach = fileInformations.id;
						this.validateFile = false;
					});
				} else {
					this.clearFiles();
				}
			}
		},
		clearFiles: function () {
			this.inviteDetails.attach = 0;
			this.fileName = null;
			this.$refs["file-input"]?.reset();
		},
		clickFileIcon: function () {
			if (this.inviteDetails.attach && this.inviteDetails.attach > 0) {
				this.downloadInviteDocument(this.inviteDetails.attach);
			} else {
				document.getElementById("uploadFileInput").click();
			}
		},
		setSelectedSupplierParent: function (supplierParent) {
			this.supplierParentEntails = [];
			if (this.screenType == this.$inviteTabsType.inviteProcess || this.offerId) {
				if (supplierParent != null) {
					const filteredSupplierConst = {
						nameFilter: supplierParent.supplierName,
						cnpjCpfFilter: supplierParent.cnpjCpf
					};
					this.selectedSupplierParent = supplierParent.idSupplier;
					this.getFilteredSuppliers(filteredSupplierConst);
					this.getSupplierEntails(supplierParent.idSupplier).then((response) => {
						if (response.length > 0) {
							response.forEach((supplierName) => {
								this.supplierParentEntails.push(supplierName.supplierName);
							});
						}
					});
					f;
					this.getUserById(supplierParent.idUser).then((resp) => {
						this.supplierParentEmail = resp.email;
					});
				}
			} else if (supplierParent != null) {
				this.selectedSupplierParent = supplierParent.idSupplier;
				this.getSupplierEntails(supplierParent.idSupplier).then((response) => {
					response.forEach((supplierName) => {
						this.supplierParentEntails.push(supplierName.supplierName);
					});
				});
				this.getUserById(supplierParent.idUser).then((response) => {
					this.supplierParentEmail = response.email;
				});
			}
		},
		callbackOk: function () {
			this.getSupplierEmailConfiguration(this.inviteDetails).then((response) => {
				let supplierData = this.inviteDetails;
				this.validateHidden = true;

				if (response.centralEmail == true && supplierData.email.length != 0) {
					response.email = this.inviteDetails.email;
					this.crudKey++;
					this.checkEmail = response.email;
					this.supplierUpdateEmail(response);
				} else if (response.centralEmail == false && supplierData.email.length != 0) {
					response.email = this.inviteDetails.email;
					this.inviteDetailsKey++;
					this.checkEmail = response.email;
					this.createSupplierEmail(response);
				}
			});
		},
		callbackCanceled: function () {
			this.getSupplierEmailConfiguration(this.inviteDetails).then((response) => {
				if (response) {
					this.inviteDetails.email = response.email;
					this.inviteDetailsKey++;
					this.checkEmail = response.email;
					this.$functions.displayInfo(
						this,
						this.$t("pages.newInviteSupplier.modals.editEmail.sendEmailInfo", [this.checkEmail])
					);
				}
			});
		},
		hideModal: function () {
			this.getSupplierEmailConfiguration(this.inviteDetails).then((response) => {
				if (response && this.validateHidden == false) {
					this.inviteDetails.email = response.email;
					this.inviteDetailsKey++;
					this.checkEmail = response.email;
				}
			});
		},
		fieldChange: function (fieldName) {
			if (fieldName == "country") {
				this.inviteDetails.personType =
					this.inviteDetails.country?.toLowerCase() != "brasil" ? this.$PersonType.NIF : this.$PersonType.PJ;
			}
			if (
				fieldName == "personType" &&
				this.screenType != this.$inviteTabsType.inviteProcess &&
				!this.inviteRehomologation
			) {
				switch (this.inviteDetails.personType) {
					case this.$PersonType.NIF:
						this.deleteFieldsInviteDetailsOnFieldChange([
							"birthDate",
							"cnpjCpf",
							"uf",
							"stateRegistration",
							"municipalRegistration",
							"supplierName"
						]);
						this.inviteDetailsKey++;
						break;
					case this.$PersonType.PF:
						this.deleteFieldsInviteDetailsOnFieldChange(["nif", "uf"]);
						this.inviteDetails.cnpjCpf = null;
						this.inviteDetailsKey++;
						break;
					case this.$PersonType.PJ:
						this.deleteFieldsInviteDetailsOnFieldChange(["birthDate", "nif"]);
						this.inviteDetails.cnpjCpf = null;
						this.inviteDetailsKey++;
						break;
				}
			}
			if (
				(fieldName == "flowType" || fieldName == "personType" || fieldName == "country") &&
				!this.inviteRehomologation
			) {
				if (this.screenType != this.$inviteTabsType.inviteProcess) {
					if (this.inviteDetails.country?.toLowerCase() != "brasil") {
						this.getGeneralRequirements(
							this.getGeneralRequirementDataObject(
								this.$PersonType.NIF,
								this.inviteDetails.stateRegistration,
								this.inviteDetails.municipalRegistration,
								true
							)
						);
						this.getSpecficRequirements();
					} else {
						this.getGeneralRequirements(
							this.getGeneralRequirementDataObject(
								this.inviteDetails.personType,
								this.inviteDetails.stateRegistration,
								this.inviteDetails.municipalRegistration,
								true
							)
						);
						this.getSpecficRequirements();
					}
				}
			}
		},
		determineInviteType(supplierId, idSupplier, supplierCode) {
			if (this.inviteRehomologation) return this.inviteType;

			return !supplierId && idSupplier > 0 && supplierCode
				? this.$InviteType.MODIFICATION_CREATION
				: this.$InviteType.NORMAL_CREATION;
		},
		handleSupplierData(dataObject) {
			this.getSupplierData(dataObject).then((response) => {
				const {
					supplierContact,
					supplierBank,
					supplierEmail,
					supplierAddress,
					idSupplier,
					supplierCode,
					supplierName,
					personType,
					birthDate = "",
					country,
					uf = ""
				} = response;

				this.idSupplier = idSupplier;
				this.inviteDetails.supplierName = supplierName;
				this.inviteDetails.birthDate = this.inviteDetails.birthDate || birthDate;
				this.inviteDetails.uf = this.inviteDetails.uf || uf;

				if (country)
					this.inviteDetails.country =
						personType == this.$PersonType.NIF ? country : this.inviteDetails.country || country;

				this.inviteType = this.determineInviteType(this.supplierId, idSupplier, supplierCode);

				this.dataContact = this.formatContactData(supplierContact);
				this.dataBank = this.formatBankData(supplierBank);
				this.loadSupplierAddress(supplierAddress);

				const { email, inviteEmail } = supplierEmail || {};
				this.inviteDetails.email = email || "";
				this.inviteDetails.inviteEmail = inviteEmail || email || "";
				this.checkEmail = email || "";

				this.fileName = this.$refs["file-input"]?.files[0]?.name;

				this.inviteDetailsKey++;
			});
		},
		async handleRegistrationDataRefresh(shouldRefresh) {
			if (!shouldRefresh) return;

			const dataObject = this.buildSupplierDataObject();
			if (this.isValidDataObject(dataObject)) {
				await this.handleSupplierData(dataObject);
			}
		},
		buildSupplierDataObject() {
			return {
				idClient: this.actualUser.idClient,
				cnpjCpf:
					this.inviteDetails.personType === this.$PersonType.NIF
						? this.inviteDetails.nif
						: this.inviteDetails.cnpjCpf?.replace(/[^A-Za-z0-9]/g, "").toUpperCase(),
				stateRegistration: this.inviteDetails.stateRegistration,
				municipalRegistration: this.inviteDetails.municipalRegistration
			};
		},
		isValidDataObject(dataObject) {
			return !!(dataObject.cnpjCpf || dataObject.municipalRegistration || dataObject.stateRegistration);
		},
		deleteFieldsInviteDetailsOnFieldChange(fields) {
			fields.forEach((field) => {
				if (this.inviteDetails.hasOwnProperty(field)) {
					delete this.inviteDetails[field];
				}
			});
		},
		ValidateCnpjCpf() {
			switch (this.inviteDetails.personType) {
				case this.$PersonType.PF:
					return this.$validations.cpf;
				case this.$PersonType.PJ:
					return this.$validations.cnpj;
			}
		},
		showWorkflowModal(action) {
			this.$refs.WorkflowHistoryMessageModal.setAcao(action);
			this.$bvModal.show("workflowHistoryMessageModal");
		},
		getWorkflowSendInvite: function () {
			let workflow = this.workflows.find((w) => w.id == this.inviteDetails.idWorkflow);
			this.workflowSendsInvite = workflow?.sendInvite ?? true;
		},
		cleanFamiliesRequirementsSelected() {
			this.cleanRequirementsByFamily();
			this.cleanSpecificRequirements();
			this.setListItensSelectedOnState([]);
		},
		filterFamiliesByWorkflow(workflowId, cleanRequirements) {
			try {
				const isRehomologationProcess = this.supplierId && this.screenType == this.$inviteTabsType.inviteCreation;
				if (isRehomologationProcess) return;

				const originalFamilies = JSON.parse(sessionStorage.getItem("originalFamilies") || "[]");
				const workflow = this.workflows.find((wf) => wf.id === workflowId);
				if (workflow && workflow.workflowFamilies && workflow.workflowFamilies.length > 0) {
					const filteredFamilies = originalFamilies.filter((family) =>
						workflow.workflowFamilies.includes(family.idFamily)
					);
					this.setFamiliesOnState(filteredFamilies);
					this.setStatusOnTree();
				} else {
					this.setFamiliesOnState(originalFamilies);
					this.setStatusOnTree();
				}
				if (cleanRequirements) {
					this.cleanFamiliesRequirementsSelected();
				}
			} catch (error) {
				console.error("Erro ao processar famílias:", error);
				this.setFamiliesOnState([]);
			}
		},
		handleBlur: function (field) {
			if (field === "country" && this.currentStep == 2) {
				this.supplierData.uf = "";
			}

			if (this.screenType != this.$inviteTabsType.inviteCreation) return;

			let data = this.inviteDetails;
			if (field && (field.name == "cnpjCpf" || field.name == "nif")) {
				if (data.cnpjCpf) {
					this.getCheckBlackListed({ cnpjCpf: data.cnpjCpf, key: "" }).then((response) => {
						if (response.isBlackListed) {
							const personTypesMap = {
								[this.$PersonType.PF]: "CPF",
								[this.$PersonType.PJ]: "CNPJ"
							};

							const personType = personTypesMap[this.inviteDetails.personType] || "NIF";
							this.$functions.displayError(this, this.$t("pages.newInviteSupplier.supplierBlacklisted", [personType]));
							this.inviteDetails.cnpjCpf = null;
							return;
						}
					});
				}
			}

			if (field.name == "stateRegistration" || field.name == "municipalRegistration") {
				this.getGeneralRequirements(
					this.getGeneralRequirementDataObject(
						this.inviteDetails.personType,
						this.inviteDetails.stateRegistration,
						this.inviteDetails.municipalRegistration,
						true
					)
				);
				this.getSpecficRequirements();
			}

			if (
				(field &&
					(field.name == "municipalRegistration" || field.name == "stateRegistration" || field.name == "cnpjCpf") &&
					this.configurations.MunicipalAndStateRegistration) ||
				field.name == "nif"
			) {
				if (
					data.cnpjCpf ||
					data.municipalRegistration ||
					data.stateRegistration ||
					(data.nif && data.personType == this.$PersonType.NIF)
				) {
					const dataObject = this.buildSupplierDataObject();
					if (this.isValidDataObject(dataObject)) {
						this.handleSupplierData(dataObject);
					}
				} else {
					data.supplierName = "";
					data.email = "";
					data.inviteEmail = "";
					this.inviteDetailsKey++;
				}
			}
			if (field == "idWorkflow") {
				this.filterFamiliesByWorkflow(this.inviteDetails.idWorkflow, true);
				this.getWorkflowSendInvite();
				if (!this.workflowSendsInvite && this.screenType == this.$inviteTabsType.inviteCreation) {
					this.inviteDetails.sendCopyInviteEmail = false;
					this.inviteDetailsKey++;
				}
			}
			if ((field && field.name == "email") || field.name == "inviteEmail") {
				if (!this.inviteDetails.inviteEmail) {
					this.inviteDetails.inviteEmail = this.inviteDetails.email;
					this.inviteDetailsKey++;
				}
				this.validateHidden = false;
				if (this.workflowSendsInvite || this.inviteDetails.email) {
					let newEmailValidation = this.$validateEmail(data.email);
					this.getSupplierEmailConfiguration(data).then((response) => {
						if (
							response.idClient != 0 &&
							response.email != data.email &&
							newEmailValidation != false &&
							!this.emailExist
						) {
							this.$bvModal.show("editEmailModal");
						}
					});
				}
			}
			if (!data.cnpjCpf && this.data) {
				this.data.email = null;
			}
			if (field.name == "cnpjCpf" && !this.configurations.MunicipalAndStateRegistration) {
				if (this.inviteDetails.cnpjCpf) {
					const dataObject = {
						idClient: this.actualUser.idClient,
						cnpjCpf: this.inviteDetails.cnpjCpf.replace(/[^A-Za-z0-9]/g, "").toUpperCase(),
						stateRegistration: "",
						municipalRegistration: ""
					};
					this.handleSupplierData(dataObject);
				}
			}

			this.inviteDetailsKey++;
		},
		checkIfHasReevaluationStatus: function () {
			if (
				this.specificRequirements.some((req) => req.status == 7) ||
				this.generalRequirements.some((req) => req.status == 7)
			)
				return true;
			return false;
		},
		async checkNextStepAdvance(action, requirementProperties) {
			const actionType = this.$ActionType;
			const validationResult = await this.validateRequiredFields();

			if (!validationResult.isValid) {
				return false;
			}

			const requirementChecks = this.extractRequirementChecks(requirementProperties);

			if (this.isCancelAction(action, actionType)) {
				return true;
			}

			const validationChecks = [
				() => this.validateConcludedAction(action, actionType, requirementChecks),
				() => this.validateReevaluationRequirements(action, actionType, requirementChecks),
				() => this.validateMandatoryRequirements(action, requirementChecks),
				() => this.validateSpecificRequirements(action, requirementChecks),
				() => this.validateGeneralRequirements(action, requirementChecks),
				() => this.validateNonObrigatoryRequirements(action, requirementChecks),
				() => this.validateInvalidRequirements(action, actionType, requirementChecks),
				() => this.validateRefusedRequirements(action, actionType, requirementChecks)
			];

			for (const validation of validationChecks) {
				const result = validation();
				if (result !== null) {
					return result;
				}
			}

			return true;
		},
		async validateRequiredFields() {
			try {
				const allFieldsValid = await this.$refs.SupplierDetailsKCrud.validateAllFields();

				if (!allFieldsValid) {
					this.handleValidationError(2);
					return { isValid: false };
				}

				if (!this.validateBankRequiredFields()) {
					this.handleValidationError(3);
					return { isValid: false };
				}

				return { isValid: true };
			} catch (error) {
				console.error("Erro na validação de campos:", error);
				this.handleValidationError(2);
				return { isValid: false };
			}
		},
		validateBankRequiredFields() {
			if (!this.$refs.BankInfoOne || !this.$refs.BankInfoTwo) return true;

			const kcrudValid =
				this.$refs.BankInfoOne.validateAllFields() && this.$refs.BankInfoTwo.validateAllFields();

			const autoCompleteMissing =
				(this.isBankFieldValidationRequired("bank") && !this.dataBank.bankDescription) ||
				(this.isBankFieldValidationRequired("agency") &&
					(!this.dataBank.agencyDescription || !this.dataBank.agencyDigit));

			return kcrudValid && !autoCompleteMissing;
		},
		handleValidationError(step = 2) {
			this.$functions.displayError(this, this.$t("pages.newInviteSupplier.warning.mandatoryFillMandatoryFields"));
			this.currentStep = step;
			this.loading = false;
		},
		async ensureRegistrationDataSaved() {
			if (!this.registrationDataSaved) {
				try {
					await this.saveRegistrationData({ showAlert: false });
				} catch (error) {
					console.error("Erro ao salvar dados de registro:", error);
				}
			}
			if (this.$refs.BankInfoOne && this.$refs.BankInfoTwo && this.isAnyBankFieldEditable()) {
				try {
					await this.saveBankData({ showAlert: false });
				} catch (error) {
					console.error("Erro ao salvar dados bancários:", error);
				}
			}
		},
		isCancelAction(action, actionType) {
			return action.tipo === actionType.Canceled;
		},
		extractRequirementChecks(requirementProperties) {
			const {
				specificRequirementsProperties,
				generalRequirementsProperties,
				validateSpecificRequirementsNotValid,
				validateGeneralRequirementsNotValid,
				hasReevaluationSpecificRequirements,
				hasGeneralReevaluationRequirements,
				hasInvalidRequirement,
				hasRefusedRequirement,
				hasMandatoryRequirementWithPartialAnswerStatus,
				reevaluationFillerActorIds
			} = requirementProperties;

			return {
				specificRequirementsNotValid:
					specificRequirementsProperties.notValidRequirements || validateSpecificRequirementsNotValid,

				requiresReevaluation: hasReevaluationSpecificRequirements || hasGeneralReevaluationRequirements,

				anyUnfilledRequirement:
					specificRequirementsProperties.anyNotFilledRequirement ||
					generalRequirementsProperties.anyNotFilledRequirement,

				generalRequirementsNotValid:
					generalRequirementsProperties.notValidRequirements || validateGeneralRequirementsNotValid,

				nonObrigatoryRequirements:
					specificRequirementsProperties.notObrigatoryRequirements ||
					generalRequirementsProperties.notObrigatoryRequirements,

				hasInvalidRequirement,
				hasRefusedRequirement,
				hasReevaluationSpecificRequirements,
				hasGeneralReevaluationRequirements,
				hasMandatoryRequirementWithPartialAnswerStatus,
				reevaluationFillerActorIds
			};
		},
		validateConcludedAction(action, actionType, checks) {
			if (action.tipo === actionType.Concluded && checks.anyUnfilledRequirement) {
				this.showValidationWarning("pages.newInviteSupplier.nextStepError.mandatoryRequirementPending");
				return false;
			}
			return null;
		},
		validateReevaluationRequirements(action, actionType, checks) {
			const isStepOrConcluded = action.tipo === actionType.Step || action.tipo === actionType.Concluded;
			const actorNotInReevaluation = checks.reevaluationFillerActorIds.indexOf(action.destinationStepIdActor) === -1;

			if (checks.requiresReevaluation && isStepOrConcluded && actorNotInReevaluation) {
				this.showValidationWarning("pages.newInviteSupplier.nextStepError.requirementPending");
				return false;
			}

			if (checks.requiresReevaluation && action.tipo === actionType.Returned) {
				return true;
			}

			return null;
		},
		validateMandatoryRequirements(action, checks) {
			const hasMandatoryIssues =
				checks.specificRequirementsNotValid ||
				checks.generalRequirementsNotValid ||
				checks.hasMandatoryRequirementWithPartialAnswerStatus;

			if (hasMandatoryIssues) {
				this.showValidationWarning("pages.newInviteSupplier.nextStepError.mandatoryRequirementPending");
				return false;
			}
			return null;
		},
		validateSpecificRequirements(action, checks) {
			if (checks.specificRequirementsNotValid && checks.requiresReevaluation) {
				this.showValidationWarning("pages.newInviteSupplier.nextStepError.specificRequirementWaitingValidation");
				return false;
			}

			if (checks.specificRequirementsNotValid && !checks.hasReevaluationSpecificRequirements) {
				this.showValidationWarning("pages.newInviteSupplier.nextStepError.specificRequirementWaitingValidation");
				return false;
			}
			return null;
		},
		validateGeneralRequirements(action, checks) {
			if (checks.generalRequirementsNotValid && !checks.hasGeneralReevaluationRequirements) {
				this.showValidationWarning("pages.newInviteSupplier.nextStepError.generalRequirementWaitingValidation");
				return false;
			}

			return null;
		},
		validateNonObrigatoryRequirements(action, checks) {
			const hasNonObrigatoryIssues = checks.nonObrigatoryRequirements && !checks.generalRequirementsNotValid;
			if (hasNonObrigatoryIssues) {
				this.showNonObrigatoryRequirementsModal(action);
				return false;
			}
			return null;
		},
		showNonObrigatoryRequirementsModal(action) {
			this.excluirModal(this.modalRequirementConfirmConfigs).OK(() => {
				this.confirmNextStep = true;
				this.showWorkflowModal(action);
			});
		},
		validateInvalidRequirements(action, actionType, checks) {
			if (checks.hasInvalidRequirement && action.tipo === actionType.Concluded) {
				this.showValidationWarning("pages.newInviteSupplier.nextStepError.finishInvite.requirementWaitingValidation");
				return false;
			}
			return null;
		},
		validateRefusedRequirements(action, actionType, checks) {
			const isStepOrConcluded = action.tipo === actionType.Concluded || action.tipo === actionType.Step;
			if (checks.hasRefusedRequirement && isStepOrConcluded) {
				this.showValidationWarning("pages.newInviteSupplier.nextStepError.mandatoryRequirementRefused");
				return false;
			}
			return null;
		},
		showValidationWarning(messageKey) {
			this.hasTriedToAvanced = true;
			this.$functions.displayWarning(this, this.$t(messageKey));
		},
		openNextStepModal(action) {
			const requirementPropertiesObj = this.getRequirementProperties();
			this.checkNextStepAdvance(action, requirementPropertiesObj).then((response) => {
				if (response) {
					this.showWorkflowModal(action);
				}
			});
		},
		getRequirementProperties() {
			const actorId = this.actualStepActor;
			const mappedStatus = (status) => this.mapBackStatusToFrontStatus(status);
			const reevaluationPendingStatus = this.$RequirementStatus.InReevaluation;
			const invalidStatus = [this.$RequirementStatus.Done, this.$RequirementStatus.InProgress];
			const refusedStatus = this.$RequirementStatus.Rejected;

			const specificRequirementsProperties = this.checkRequirements(this.specificRequirements, actorId, mappedStatus);
			const toValidateFilteredSpecificRequirements = this.specificRequirements.filter(
				(requirement) =>
					requirement.status == this.$RequirementStatus.InProgress || requirement.status == this.$RequirementStatus.Done
			);
			const toValidateSpecificRequirements = this.filterRequirements(
				toValidateFilteredSpecificRequirements,
				actorId,
				"idValidateActorList"
			);
			const hasReevaluationSpecificRequirements = this.hasReevaluationRequirements(
				reevaluationPendingStatus,
				this.specificRequirements
			);

			const generalRequirementsProperties = this.checkRequirements(this.generalRequirements, actorId, mappedStatus);
			const toValidateFilteredGeneralRequirements = this.generalRequirements.filter(
				(requirement) =>
					requirement.status == this.$RequirementStatus.InProgress || requirement.status == this.$RequirementStatus.Done
			);
			const toValidateGeneralRequirementsActor = this.filterRequirements(
				toValidateFilteredGeneralRequirements,
				actorId,
				"idValidateActorList"
			);
			const hasGeneralReevaluationRequirements = this.hasReevaluationRequirements(
				reevaluationPendingStatus,
				this.generalRequirements
			);

			//Reevaluation
			const generalReevaluationFillerActorIds = this.getRequirementFillerActorIds(
				this.generalRequirements,
				reevaluationPendingStatus
			);
			const specificReevaluationFillerActorIds = this.getRequirementFillerActorIds(
				this.specificRequirements,
				reevaluationPendingStatus
			);
			const reevaluationFillerActorIds = [...generalReevaluationFillerActorIds, ...specificReevaluationFillerActorIds];

			const hasInvalidStatus = (list) => list?.some((r) => invalidStatus.includes(r.status));
			const validateSpecificRequirementsNotValid = hasInvalidStatus(toValidateSpecificRequirements);
			const validateGeneralRequirementsNotValid = hasInvalidStatus(toValidateGeneralRequirementsActor);

			const hasInvalidRequirement =
				this.specificRequirements.some((requirement) => {
					const { statusId } = mappedStatus(requirement.status);
					return requirement.isMandatory && invalidStatus.includes(statusId);
				}) ||
				this.generalRequirements.some((requirement) => {
					const { statusId } = mappedStatus(requirement.status);
					return requirement.isMandatory && invalidStatus.includes(statusId);
				});

			const hasRefusedRequirement =
				this.specificRequirements.some((requirement) => {
					const { statusId } = mappedStatus(requirement.status);
					return requirement.isMandatory && refusedStatus == statusId;
				}) ||
				this.generalRequirements.some((requirement) => {
					const { statusId } = mappedStatus(requirement.status);
					return requirement.isMandatory && refusedStatus == statusId;
				});

			const hasMandatoryRequirementWithPartialAnswerStatus =
				this.hasMandatoryRequirementWithPartialAnswerStatusConcise();

			return {
				hasReevaluationSpecificRequirements,
				hasGeneralReevaluationRequirements,
				reevaluationFillerActorIds,
				specificRequirementsProperties,
				generalRequirementsProperties,
				validateSpecificRequirementsNotValid,
				validateGeneralRequirementsNotValid,
				hasInvalidRequirement,
				hasRefusedRequirement,
				hasMandatoryRequirementWithPartialAnswerStatus
			};
		},
		hasMandatoryRequirementWithPartialAnswerStatusConcise() {
			const allRequirements = [...this.specificRequirements, ...this.generalRequirements];

			return allRequirements
				.filter((req) => req.isMandatory && req.status === this.$RequirementStatus.PartialAnswer)
				.some((req) => {
					const isSpecific = this.specificRequirements.includes(req);
					const list = isSpecific ? this.specificRequirementList : this.generalRequirementList;
					const actions = list.find((item) => item.idRequirement === req.idRequirement)?.actions || {};
					const { edit = false, validate = false, view = false } = actions;
					const isViewOnlyMode = !edit && !validate && view;

					return !isViewOnlyMode;
				});
		},
		checkRequirements(requirements, actorId, mappedStatus, isMandatory = true) {
			const toFillRequirements = this.filterRequirements(requirements, actorId);
			const notValidRequirements = this.checkRequirementStatus(
				toFillRequirements,
				mappedStatus,
				"isMandatory",
				this.$RequirementStatus.Pending,
				isMandatory
			);
			const anyNotFilledRequirement = this.checkRequirementStatus(
				requirements,
				mappedStatus,
				"isMandatory",
				this.$RequirementStatus.Pending
			);
			const notObrigatoryRequirements = this.checkRequirementStatus(
				toFillRequirements,
				mappedStatus,
				"isMandatory",
				this.$RequirementStatus.Pending,
				false
			);
			return {
				toFillRequirements,
				notValidRequirements,
				anyNotFilledRequirement,
				notObrigatoryRequirements
			};
		},
		getRequirementFillerActorIds(requirements, reevaluationStatus) {
			return requirements
				.filter((requirement) => {
					const { statusId } = this.mapBackStatusToFrontStatus(requirement.status);
					return reevaluationStatus === statusId;
				})
				.map((requirement) => requirement.idFillerActor);
		},
		filterRequirements(requirements, actorId, field = "idFillerActor") {
			// TODO anderson.bauermann quando implementar a funcionalidade de multiplos atores poderem preencher um requisito
			// eliminar esse parametro "field" e utilizar a role para determinar o filtro de atuação, evitando comparação por string e sendo uma abordagem mais robusta
			if (field === "idValidateActorList") {
				return requirements.filter((req) => req[field].includes(actorId));
			}

			return requirements.filter((requirement) => requirement[field] == actorId);
		},
		hasReevaluationRequirements(reevaluationPendingStatus, requirements) {
			const mapEnhancedRequirements = (baseList, specificList) => {
				return baseList.map((requirement) => {
					const matchingSpecificRequirement = specificList.find(
						(specific) => specific.idRequirement === requirement.idRequirement
					);

					return {
						...requirement,
						actions: matchingSpecificRequirement?.actions || []
					};
				});
			};
			const enhancedSpecificRequirements = mapEnhancedRequirements(requirements, this.specificRequirementList);
			const enhancedGeneralRequirements = mapEnhancedRequirements(requirements, this.generalRequirementList);
			const combinedRequirements = [...enhancedSpecificRequirements, ...enhancedGeneralRequirements];

			return combinedRequirements.some(({ status, actions }) => {
				const { statusId } = this.mapBackStatusToFrontStatus(status);
				return statusId === reevaluationPendingStatus && (actions.validate || actions.edit);
			});
		},
		checkRequirementStatus(requirements, mappedStatus, isMandatoryField, statusToCheck, isMandatory = true) {
			return requirements.some((requirement) => {
				const isArrayStatus = Array.isArray(statusToCheck);
				const { statusId } = mappedStatus(requirement.status);
				return (
					requirement[isMandatoryField] == isMandatory &&
					(statusToCheck == statusId || (isArrayStatus && statusToCheck.some((status) => status == statusId)))
				);
			});
		},
		mapStatusArray(statusArray, mapperFunction) {
			return statusArray.map(mapperFunction);
		},
		hasStepError(resultStep, nextStep) {
			return resultStep.idStep === nextStep.currentIdStep;
		},
		showStepBlockingPendencies() {
			this.$functions.displayError(this, this.$t("pages.newInviteSupplier.nextStepError.workflowStepPendencies"));
		},
		showSuccessMessage(stepName) {
			const successMessage = this.$t("messages.workflowAdvancedStep", [stepName]);
			this.$functions.displaySuccess(this, successMessage);
		},
		navigateToEnterpriseList() {
			this.$router.push({
				name: "enterpriseList",
				params: {}
			});
		},
		async nextStep(action) {
			let pendingStatus = [this.$RequirementStatus.Pending];
			//requisitos gerais
			let toFillGeneralRequirements = this.generalRequirements.filter(
				(req) => req.idFillerActor == this.actualStepActor
			);
			//requisitos específicos
			let toFillSpecificRequirements = this.specificRequirements.filter(
				(req) => req.idFillerActor == this.actualStepActor
			);

			const toFillRequirements = [...toFillGeneralRequirements, ...toFillSpecificRequirements];
			let hasNotObrigatoryRequirementsNotFilled = toFillRequirements.some((req) => {
				const { statusDescription } = this.mapBackStatusToFrontStatus(req.status);
				return req.canView && !req.isMandatory && pendingStatus == statusDescription;
			});

			if (this.shouldConfirmNextStep(hasNotObrigatoryRequirementsNotFilled, toFillRequirements)) {
				this.confirmNextStep = true;
			}

			var nextStep = {
				idInvite: this.idInvite,
				currentIdStep: this.idStep,
				actionOrder: action.actionId,
				nextStepMessage: action.message,
				confirmNextStep: this.confirmNextStep,
				isReturnStep: action.tipo == this.$ActionType.Returned
			};
			if (action.tipo == this.$ActionType.Canceled) {
				this.cancelInvite(nextStep).then(
					() => {
						this.$functions.displaySuccess(this, this.$t("pages.newInviteSupplier.inviteSuccessfullyCanceled"));
						this.$router.push({
							name: "enterpriseList",
							params: {}
						});
					},
					(error) => {
						this.$functions.displayError(
							this,
							this.$t("messages.inviteCancelationFail") + "\n" + error.response.data.error.message
						);
					}
				);
				return;
			}
			this.nextStepWorkflow(nextStep).then(
				(result) => {
					// TODO @rafael.silva workflow paralelo
					let resultStep = result.resultSteps[0];
					switch (result.idStatus) {
						case 3:
							if (this.actualUserIsClient)
								this.$functions.displaySuccess(this, this.$t("pages.newInviteSupplier.supplierHomologated"));
							else this.$functions.displaySuccess(this, this.$t("pages.newInviteSupplier.inviteSuccessfullyConcluded"));
							this.$router.push({
								name: "enterpriseList",
								params: {}
							});
							break;
						case 4:
							this.$functions.displaySuccess(this, this.$t("pages.newInviteSupplier.inviteSuccessfullyCanceled"));
							this.$router.push({
								name: "enterpriseList",
								params: {}
							});
							break;
						default:
							if (this.checkIfHasReevaluationStatus()) {
								const validActionTypes = [
									this.$ActionType.Step,
									this.$ActionType.Returned,
									this.$ActionType.Integration
								];

								if (validActionTypes.includes(action.tipo)) {
									if (this.hasStepError(resultStep, nextStep)) {
										this.showStepBlockingPendencies();
										return;
									}
									this.showSuccessMessage(resultStep.stepName);
									this.navigateToEnterpriseList();
								}
							} else if (
								this.isNotPossibleAdvanceStep(resultStep.idStep, hasNotObrigatoryRequirementsNotFilled, action.Tipo)
							) {
								this.$functions.displayWarning(this, this.$t("messages.verifyRequirement"));
							} else {
								if (this.hasStepError(resultStep, nextStep)) {
									this.showStepBlockingPendencies();
									return;
								}

								if (this.actualUserIsClient) {
									this.$functions.displaySuccess(this, this.$t("messages.workflowAdvancedStep", [resultStep.stepName]));
								} else {
									this.$functions.displaySuccess(this, this.$t("messages.answersSendedSuccessfully"));
								}

								this.navigateToEnterpriseList();
							}
							break;
					}
				},
				(error) => {
					this.$functions.displayError(this, this.$t("pages.newInviteSupplier.nextStepError.unknowError"));
					console.error("error.response.data.error.message :", error.response.data.error.message);
				}
			);
		},
		shouldConfirmNextStep(hasNotObrigatoryRequirementsNotFilled, toFillRequirements) {
			return (
				!hasNotObrigatoryRequirementsNotFilled &&
				toFillRequirements.every((req) => !req.isMandatory) &&
				!this.confirmNextStep
			);
		},
		isNotPossibleAdvanceStep(idStep, hasNotObrigatoryRequirements, actionType) {
			return idStep == this.idStep && hasNotObrigatoryRequirements && actionType != this.$ActionType.Integration;
		},
		async reevaluationReprocess(requirements) {
			try {
				for (let c = 0; c < requirements.length; c++) {
					let isSystemRequirement = requirements[c].idFillerActor == this.$FillerActor.PUBLIC_CONSULTATIONS_ACTOR;

					if (isSystemRequirement) {
						let reqObj = {
							idInvite: this.idInvite,
							idRequirement: requirements[c].idRequirement
						};
						await this.reprocessIntegration(reqObj);
					}
				}
				return true;
			} catch (e) {
				console.error(e);
				return false;
			}
		},
		async nextStepConfirm(action) {
			await this.ensureRegistrationDataSaved();

			const inProgressRequirements = [...this.specificRequirementList, ...this.generalRequirementList]
				.filter((req) => req.status === this.$RequirementStatus.InProgress)
				.map((req) => this.mapFrontToBack(req));
			const reprocessRequirements = this.specificRequirements.filter(
				(req) => req.isIntegration && req.status === this.$RequirementStatus.InReevaluation
			);
			if (reprocessRequirements.length > 0) {
				const response = await this.reevaluationReprocess(reprocessRequirements);
				if (response) {
					await this.updateRequirementsResponseWorkflow({ requirements: inProgressRequirements });
					this.nextStep(action);
				}
			} else {
				await this.updateRequirementsResponseWorkflow({ requirements: inProgressRequirements });
				this.nextStep(action);
			}
		},
		mapFrontToBack(req) {
			let mappedReq = {
				idInvite: this.idInvite,
				idRequirement: req.idRequirement,
				status: this.$RequirementStatus.Done
			};
			return mappedReq;
		},
		back: function () {
			this.$router.push({
				name: "enterpriseList"
			});
		},
		selectAllCompanies: function (allSelected) {
			let companyName = [];
			this.companyOptions.forEach((group) => {
				group.selected = allSelected;
				group.children.forEach((child) => {
					child.selected = allSelected;
					if (allSelected) companyName.push(child.value);
				});
			});
			this.selectedCompanies = companyName;

			this.newInviteSupplierData.companyName = companyName;
			if (this.screenType != this.$inviteTabsType.inviteProcess) this.getSpecficRequirements();
		},
		async getSpecficRequirements() {
			let obj = {
				familyList: this.listItensSelected,
				companyList: this.selectedCompanies,
				flowType: this.inviteDetails.flowType,
				personType: this.inviteDetails.personType,
				stateRegistration: this.inviteDetails.stateRegistration,
				municipalRegistration: this.inviteDetails.municipalRegistration,
				isCustomerInvite: true,
				idSupplier: this.idSupplier
			};

			if (this.inviteDetails.country?.toLowerCase() != "brasil") {
				obj.personType = this.$PersonType.NIF;
			}

			//Parâmetros para a busca de requisitos
			this.setSelectedCompaniesOnState(this.selectedCompanies);

			let isOK = this.validateAllFieldsGetRequirement();
			if (isOK) {
				this.loading = true;
				await this.getFullTreeListByIdFamily(obj);
				this.loading = false;
			} else this.setSpecificRequirementsOnState([]);
		},
		discardCompaniesAndFamiliesChanges: function () {
			this.selectedCompanies = JSON.parse(JSON.stringify(this.oldSelectedCompanies));

			this.companyOptions.forEach((group) => {
				group.children.forEach((child) => {
					if (this.selectedCompanies.indexOf(child.value) != -1) {
						child.selected = true;
						group.selected = true;
					}
				});
			});

			this.selectedFamilies = JSON.parse(JSON.stringify(this.oldSelectedFamilies));
			this.setListItensSelectedOnState(this.selectedFamilies);
			this.setStatusOnTree();

			this.$functions.displaySuccess(this, this.$t("pages.newInviteSupplier.changesSuccessfullyDiscarded"));
		},
		requesterModalOk: function (preventDefault) {
			let allOk = this.$refs.RequesterCpfKCrud.validateAllFields();
			if (!allOk) {
				preventDefault();
				return;
			}
			this.createInvite(false);
		},
		requesterModalCancel: function () {
			this.inviteDetails.requesterCPF = "";
		},
		stepClicked: function (id) {
			if (
				(this.familiesHaveChanges || this.companiesHaveChanges) &&
				this.screenType == this.$inviteTabsType.inviteProcess
			) {
				this.$bvModal.show("inviteTabChangeModal");
			} else {
				this.navigationKey++;
				this.currentStep = id;
			}
		},
		async editRequirement(requirement) {
			let modalType = this.$requirementResponseModalType.requirementResponse;
			const allRequirements = [...this.specificRequirements, ...this.generalRequirements];
			const requirementData = allRequirements.find((req) => req.idRequirement === requirement.idRequirement);
			const isFillerValidatorOnReevaluation = this.processFillerOrValidatorOnReevaluation(requirementData);

			if (this.actualUserIsClient && !isFillerValidatorOnReevaluation) {
				if (requirement.reprocess) {
					modalType = this.$requirementResponseModalType.reprocess;
				} else if (requirement.actions.validate && requirement.idStatus !== this.$RequirementStatus.Pending) {
					modalType = this.$requirementResponseModalType.clientValidation;
				}
			}

			const questionFilter = { idClient: this.idClient, onlyActiveQuestions: false, includeAlternatives: true };
			this.getAllRequirementQuestionListByClient(questionFilter);
			const isValidateActor = requirementData.idValidateActorList?.includes(this.actualStepActor);

			const contextRequirementDetails = {
				idRequirement: requirement.idRequirement,
				idInvite: this.idInvite,
				modalType,
				reprocess: requirement.reprocess,
				netrinError: requirement.netrinError,
				idStep: this.idStep,
				idClient: this.idClient,
				isFillerValidatorOnReevaluation,
				displayType: requirement.displayType,
				supplierHasCodeERP: !this.$functions.isNullOrEmpty(this.supplierCodeERP),
				isValidateActor
			};

			if (requirement.displayType == this.$displayType.FIELD) {
				await this.$refs.ResponseRequirementModal.setContextRequirement(contextRequirementDetails);
				this.$bvModal.show("responseRequirementModal");
			} else if (requirement.displayType == this.$displayType.TABLE) {
				await this.$refs.dataTableComponent.setContextRequirement(contextRequirementDetails);
				this.$bvModal.show("dataTableComponent");
			}
		},

		async viewRequirement(requirement) {
			const contextRequirementDetails = {
				idRequirement: requirement.idRequirement,
				idInvite: this.idInvite,
				modalType: this.$requirementResponseModalType.anyView,
				reprocess: requirement.reprocess,
				netrinError: requirement.netrinError,
				idStep: this.idStep,
				idClient: this.idClient,
				displayType: requirement.displayType
			};

			if (requirement.displayType == this.$displayType.FIELD) {
				await this.$refs.ResponseRequirementModal.setContextRequirement(contextRequirementDetails);
				this.$bvModal.show("responseRequirementModal");
			} else if (requirement.displayType == this.$displayType.TABLE) {
				await this.$refs.dataTableComponent.setContextRequirement(contextRequirementDetails);
				this.$bvModal.show("dataTableComponent");
			}
		},
		onChangeFamily: function (item) {
			if (this.inviteDetails.flowType != null && this.selectedCompanies.length > 0) {
				if (item.idFamily != 0 && item.selected && this.listItensSelected.indexOf(item.idFamily) == -1) {
					this.selectedFamilies.push(item.idFamily);
					this.addInviteChildrenOnSelectedList(item);
					this.setStatusOnTree();
					if (this.screenType != this.$inviteTabsType.inviteProcess) {
						this.getSpecficRequirements();
						this.inviteDetailsKey++;
					}
				} else if (item.idFamily != 0 && !item.selected && this.listItensSelected.indexOf(item.idFamily) != -1) {
					item.key = null;
					let index = this.listItensSelected.indexOf(item.idFamily);
					if (index != -1) this.listItensSelected.splice(index, 1);

					this.actors.length = 0;
					this.deleteParentsOnSelectedList(item);
					this.deleteInviteChildrenOnSelectedList(item);
					this.setStatusOnTree();

					if (this.screenType != this.$inviteTabsType.inviteProcess) {
						this.getSpecficRequirements();
						this.inviteDetailsKey++;
					}
				}
			} else {
				if (this.selectedCompanies.length == 0)
					this.$functions.displayWarning(this, this.$t("messages.mandatorySelectCompany"));
				else if (this.inviteDetails.flowType == null)
					this.$functions.displayWarning(this, this.$t("pages.newInviteSupplier.warning.mandatorySelectWorkflowType"));
				this.selectedFamilies = [];
				this.setStatusOnTree();
			}
		},
		toggleFamily: function (preventDefault, item) {
			preventDefault();
			if (!this.appliedFilter) {
				this.getFamilyChildrens(item.idFamily).then((families) => {
					families.forEach((family) => {
						if (this.listItensSelected.find((idFamily) => idFamily == family.idFamily)) {
							Vue.set(family, "status", "added");
						} else Vue.set(family, "status", "notAdded");
					});
					Vue.set(item, "children", families);
				});
			}
		},
		cleanSupplierParent() {
			this.supplierParentEntails = [];
			this.supplierParentEmail = "";
			this.selectedSupplierParent = 0;
			this.suppliers.splice(0, this.suppliers.length);
			this.supplierParentEmailSwitch = false;
		},
		onChangeCompany: function (node) {
			if (node.isGroup) return;

			let index = this.selectedCompanies.indexOf(node.value);
			if (node.selected && index < 0) this.selectedCompanies.push(node.value);
			if (!node.selected && index >= 0) this.selectedCompanies.splice(index, 1);
			this.newInviteSupplierData.companyName = this.selectedCompanies;
			// this.cleanRequirementsByFamily();
			if (this.screenType != this.$inviteTabsType.inviteProcess) {
				this.getSpecficRequirements();
			}
		},
		cleanCadastralData: function () {
			this.supplierDetailsHasData = false;
			this.registrationDataSaved = false;
			this.supplierData = {};
		},
		cleanContactAndBankSupplier: function () {
			this.dataContact = {
				idContact: null,
				nameContact: "",
				sector: "",
				emailContact: "",
				phoneContact: "",
				cellphoneContact: ""
			};
			this.dataBank = {
				id: null,
				nameBank: "",
				agencyDescription: "",
				agencyDigit: null,
				idAgency: null,
				account: "",
				accountType: 1,
				bankDescription: "",
				idBank: null
			};
		},
		cleanChanges() {
			this.cleanContactAndBankSupplier();
			this.cleanSupplierParent();
			this.setListItensSelectedOnState([]);
			this.filterFamiliesTree([]);
			this.cleanRequirementsByFamily();
			this.cleanInvite();
			this.setSpecificRequirementsOnState([]);
			this.cleanIntegration();
			this.clearFiles();
			this.cleanCadastralData();
			this.setWorkflowTypeIfHasDefault();
			if (this.$refs.InviteDetailsKCrud) this.$refs.InviteDetailsKCrud.cleanValidation();
			this.supplierDetails = {};
			this.companyOptions.forEach((group) => {
				Vue.set(group, "selected", false);
				group.children.forEach((child) => {
					Vue.set(child, "selected", false);
				});
				this.companiesKey++;
			});
			this.workflowSendsInvite = true;
			this.inviteRehomologation = false;
			this.inviteType = this.$InviteType.NORMAL_CREATION;
			this.currentStep = 1;
			this.inviteDetailsKey++;
			this.supplierDetailsKey++;
			this.dataContactKey++;
			this.dataBankKey++;
		},
		cancelChanges: function () {
			this.cleanChanges();
			this.$router.push({
				name: "home"
			});
		},
		getRequirementActors() {
			return new Promise(async (resolve) => {
				const requirementIdList = [...this.generalRequirements, ...this.specificRequirements].map((req) => {
					if (req.idRequirement > 0) {
						return req.idRequirement;
					}
				});
				const { requirementActors } = await this.getAllRequirementActors(requirementIdList);

				resolve(requirementActors);
			});
		},
		validateWorkflow: async function () {
			return new Promise((resolve, reject) => {
				let workflowActors = [];

				//Buscar atores do requisito:
				this.getRequirementActors().then((response) => {
					//Buscar atores do workflow:
					const paramsObject = {
						id: this.inviteDetails.idWorkflow,
						idClient: this.actualUser.idClient
					};
					this.getWorkflowDetails(paramsObject).then(async (workflowDetails) => {
						if (!workflowDetails) {
							resolve();
						}

						let hasIntegrationStep = workflowDetails.etapas
							.flatMap((etapa) => etapa.saidas)
							.some((saida) => saida.tipo == "Integration");
						if (hasIntegrationStep) {
							const hasAllReqs = await this.hasAllErpRequirementsForInvite();
							if (!hasAllReqs) {
								reject();
							}
						}

						let steps = workflowDetails.etapas;

						steps.forEach((step) => {
							if (step.actor && !workflowActors.find((wfId) => wfId == step.actor.id))
								workflowActors.push(step.actor.id);
						});

						for (const { fillerActorList, validateActorList } of response) {
							const missingValidateActor = validateActorList.find((idActor) => !workflowActors.includes(idActor));
							const missingFillerActor = fillerActorList.find((idActor) => !workflowActors.includes(idActor));

							if (missingValidateActor || missingFillerActor) {
								const missingActorId = missingValidateActor || missingFillerActor;
								this.showWorkflowError(missingActorId);

								reject();
								break;
							}
						}

						resolve();
					});
				});
			});
		},
		async hasAllErpRequirementsForInvite() {
			let idSupplier = this.idSupplier > 0 ? this.idSupplier : null;
			const response = await this.fetchErpIntegrationRequirements({
				idWorkflow: this.inviteDetails.idWorkflow,
				inviteType: this.inviteType,
				idSupplier: idSupplier
			});
			const integrationRequirementList = response.integrationRequirementList.filter(
				(req) => req.personType == this.inviteDetails.personType || req.personType == null
			);

			if (integrationRequirementList.length) {
				const requirementIdList = [
					...this.generalRequirementList.flatMap(({ idRequirement }) => idRequirement),
					...this.specificRequirementList.flatMap(({ idRequirement }) => idRequirement)
				];
				const integrationRequimentIdList = integrationRequirementList.map(({ idRequirement }) => idRequirement);

				if (!integrationRequimentIdList.every((element) => requirementIdList.includes(element))) {
					const missingRequirementList = integrationRequimentIdList.filter(
						(element) => !requirementIdList.includes(element)
					);
					this.showRequirementIntegrationError(missingRequirementList, integrationRequirementList);
					return false;
				}
			}
			return true;
		},
		showRequirementIntegrationError(missingRequirement, integrationRequirement) {
			const descriptions = integrationRequirement
				.filter((item) => missingRequirement.includes(item.idRequirement))
				.map((item) => item.description);

			const descriptionFormated = descriptions.join(", ");
			if (descriptions.length > 1) {
				this.$functions.displayError(
					this,
					this.$t("pages.newInviteSupplier.inviteDoesNotHaveRequirementsNeededForErpIntegration", [descriptionFormated])
				);
			} else {
				this.$functions.displayError(
					this,
					this.$t("pages.newInviteSupplier.inviteDoesNotHaveOneRequirementNeededForErpIntegration", [
						descriptionFormated
					])
				);
			}
		},
		showWorkflowError: function (idActor) {
			this.getActors().then((actors) => {
				var actor = actors.find((actor) => actor.id == idActor);
				if (actor) {
					this.$functions.displayError(
						this,
						this.$t("pages.newInviteSupplier.workflowDoesNotContainActors", [actor.name])
					);
				} else {
					this.$functions.displayError(
						this,
						this.$t("pages.newInviteSupplier.workflowDoesNotContainActorsUnknowId", [idActor])
					);
				}
				this.loading = false;
			});
		},
		validateAllFieldsGetRequirement: function () {
			return (
				this.selectedFamilies.length > 0 && this.inviteDetails.flowType != null && this.selectedCompanies.length > 0
			);
		},
		getInviteCreationObj: function () {
			let idRequirementList = [
				...this.specificRequirementList.map((req) => req.idRequirement),
				...this.generalRequirementList.map((req) => req.idRequirement)
			];

			let mappedObj = {
				//InviteInformations
				name: this.inviteDetails.supplierName,
				uf: this.inviteDetails.uf,
				personType: this.inviteDetails.personType,
				cnpjCpf: this.inviteDetails.cnpjCpf,
				nif: this.inviteDetails.nif,
				stateRegistration:
					this.inviteDetails.stateRegistration === "" ? null : this.inviteDetails.stateRegistration ?? null,
				municipalRegistration:
					this.inviteDetails.municipalRegistration === "" ? null : this.inviteDetails.municipalRegistration ?? null,
				email: this.inviteDetails.email,
				inviteEmail: this.inviteDetails.inviteEmail,
				idWorkflowType: this.inviteDetails.flowType,
				idWorkflow: this.inviteDetails.idWorkflow,
				isInternWorkflowType: !this.workflowSendsInvite,
				country: this.inviteDetails.country,
				birthDate: this.inviteDetails.birthDate,
				duplicateSupplier: this.duplicateSupplier,
				message: this.inviteDetails.message,
				attach: this.inviteDetails.attach,
				sendAttachmentEmailInvitation: this.inviteDetails.sendAttachmentEmailInvitation ?? false,
				sendCopyInviteEmail: this.inviteDetails.sendCopyInviteEmail ?? false,
				inviteType: this.inviteDetails.inviteType,
				inviteLanguageId: this.inviteDetails.inviteLanguageId,

				//SupplierInformations
				address: this.supplierDetails.address,
				corporationName: this.supplierDetails.corporationName,
				city: this.supplierDetails.city,
				complement: this.supplierDetails.complement ? this.supplierDeatils.complement : null,
				number: this.supplierDetails.number,
				district: this.supplierDetails.district,
				zipCode: this.supplierDetails.zipCode,

				//SupplierContact
				supplierClientIdContact: this.dataContact.idContact,
				nameContact: this.dataContact.nameContact,
				sectorContact: this.dataContact.sector,
				emailContact: this.dataContact.emailContact,
				phoneContact: this.dataContact.phoneContact,
				cellphoneContact: this.dataContact.cellphoneContact,

				//SupplierBank
				supplierClientIdBank: this.dataBank.id,
				nameBank: this.dataBank.nameBank,
				idBank: this.dataBank.idBank,
				idAgencyBank: this.dataBank.idAgency,
				agencyDigit: this.dataBank.agencyDigit,
				accountBank: this.dataBank.account,
				accountBankDigit: this.dataBank.accountDigit,
				accountTypeBank:
					this.dataBank.accountType == 1 ? this.$t("commons.currentAccount") : this.$t("commons.savingsAccount"),

				//Families/Companies
				company: this.selectedCompanies,
				family: this.listItensSelected,

				//Requirement
				requirementIdList: idRequirementList,

				//Requester
				requesterCPF: this.inviteDetails.uf == "SC" ? this.inviteDetails.requesterCPF : null,

				//SupplierParent
				supplierParent: this.selectedSupplierParent,
				inviteParentEmail: this.supplierParentEmailSwitch
			};

			return mappedObj;
		},
		getOfferCreationData: function () {
			this.getOffer(this.offerId).then(() => {
				this.inviteDetails.supplierName = this.actualOffer.supplier;
				this.inviteDetails.cnpjCpf = this.actualOffer.cnpjCpf;
				this.inviteDetails.nif = this.actualOffer.personType == this.$PersonType.NIF ? this.actualOffer.cnpjCpf : null;
				this.inviteDetails.email = this.actualOffer.email;
				this.inviteDetails.inviteEmail = this.actualOffer.email;
				this.inviteDetails.flowType = this.setWorkflowType;
				this.inviteDetails.country = this.actualOffer.country;
				this.inviteDetails.uf = this.actualOffer.uf;
				this.inviteDetails.birthDate = this.actualOffer.birthDate;
				this.inviteDetails.personType = this.actualOffer.personType;

				if (this.actualOffer.supplierParentId != null && this.actualOffer.supplierParentId != 0) {
					this.getSupplierParent(this.actualOffer.supplierParentId).then((response) => {
						this.setSelectedSupplierParent(response.supplier);
					});
				}

				//Preencher companies
				let companies = this.actualOffer.companies.map((c) => c.idCompany);
				this.companyOptions.forEach((group) => {
					group.children.forEach((child) => {
						if (companies.indexOf(child.value) != -1) {
							child.selected = true;
							group.selected = true;
						}
					});
				});
				this.selectedCompanies = companies;

				//Preencher families
				let families = this.actualOffer.families.map((f) => f.idFamily);
				this.selectedFamilies = families;
				this.setListItensSelectedOnState(families);
				this.setStatusOnTree();
				this.getSpecficRequirements();
			});
		},
		validateInviteInformations: function () {
			if (this.selectedCompanies.length < 1) {
				var msg = this.$t("pages.newInviteSupplier.warning.mandatorySelectOneOrMoreCompanies");
				this.$functions.displayError(this, msg);
				this.currentStep = 4;
				this.loading = false;
				return false;
			}

			if (this.inviteDetails.sendAttachmentEmailInvitation && !("attach" in this.inviteDetails)) {
				var msg = this.$t("messages.flagEnabledWithoutAttachmentError");
				this.$functions.displayError(this, msg);
				this.currentStep = 1;
				this.loading = false;
				return false;
			}

			let allOk = this.$refs.InviteDetailsKCrud.validateAllFields();
			let allOkBankData = this.$refs.BankInfoOne.validateAllFields();
			let allOkBankDataTwo = this.$refs.BankInfoTwo.validateAllFields();

			if (!allOkBankData) {
				let bankDataFields = Object.entries(this.$refs.BankInfoOne.validation);
				if (bankDataFields.some((field) => field[1] == false)) {
					this.$functions.displayError(this, this.$t("pages.newInviteSupplier.missingBankInformation"));
					this.currentStep = 3;
				}
				this.loading = false;
				return false;
			}

			if (!allOkBankDataTwo) {
				let bankDataFields = Object.entries(this.$refs.BankInfoTwo.validation);

				if (bankDataFields.some((field) => field[1] == false)) {
					this.$functions.displayError(this, this.$t("pages.newInviteSupplier.missingBankInformation"));
					this.currentStep = 3;
				}
				this.loading = false;
				return false;
			}

			if (!allOk) {
				const inviteDetailsStepFields = Object.entries(this.$refs.InviteDetailsKCrud.validation);
				// eslint-disable-next-line no-unused-vars
				const hasInvalidFields = inviteDetailsStepFields.some(([_, isValid]) => isValid === false);

				if (hasInvalidFields) {
					this.$functions.displayError(this, this.$t("pages.newInviteSupplier.warning.mandatoryFillMandatoryFields"));
					this.currentStep = 1;
				}
				this.loading = false;
				return false;
			}

			if (this.inviteDetails.uf == "SC") {
				if (
					this.specificRequirementList.filter(
						(sr) => sr.description == "SEFAZ / Certidão Negativa de Débitos Estaduais"
					).length > 0
				)
					if (!this.inviteDetails.requesterCPF || this.inviteDetails.requesterCPF === "") {
						this.$bvModal.show("requesterCpfModal");
						this.loading = false;
						return false;
					}
			}
			if (!this.hasGeneralRequirements && !this.hasSpecificRequirements) {
				this.$functions.displayError(this, this.$t("pages.newInviteSupplier.createInviteFailWithoutRequirement"));
				this.loading = false;
				return false;
			}

			return true;
		},
		createInvite: async function (duplicateSupplier) {
			this.loading = true;
			if (!this.validateInviteInformations()) return;

			if (this.inviteDetails.cnpjCpf) {
				this.getCheckBlackListed({ cnpjCpf: this.inviteDetails.cnpjCpf, key: "" })
					.then((response) => {
						if (response.isBlackListed) {
							this.loading = false;
							this.$functions.displayError(this, this.$t("pages.newInviteSupplier.supplierCPFCNPJBlacklisted"));
							if (!this.inviteRehomologation) this.inviteDetails.cnpjCpf = null;
							return false;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			}

			if (this.shouldAssignCnpjCpfToSupplierName()) {
				this.inviteDetails.supplierName = this.inviteDetails.cnpjCpf;
			}

			if (this.isSupplierNameRequired()) {
				this.$functions.displayError(this, this.$t("pages.newInviteSupplier.necessaryToFillSupplierClientName"));
				this.currentStep = 1;
				this.loading = false;
				return false;
			}

			if (!this.configurations.HideRelationshipTab && this.configurations.DataBankObrigatority) {
				const { bankDescription, agencyDescription, agencyDigit } = this.dataBank;
				const isBankDataEmpty = !bankDescription && !agencyDescription && !agencyDigit;
				const isIncompleteBankData =
					bankDescription && this.agenciesList.length && (!agencyDescription || !agencyDigit);

				if (isBankDataEmpty || isIncompleteBankData) {
					this.$functions.displayError(this, this.$t("pages.newInviteSupplier.missingBankFieldsInformation"));
					this.loading = false;
					return false;
				}
			}

			let emailExist = false;
			if (this.workflowSendsInvite || this.inviteDetails.email) {
				let userData = {
					email: this.inviteDetails.email,
					idClient: this.actualUser.idClient,
					isCreateUser: false,
					checkAllUsers: false
				};
				await this.checkUserEmailExistance(userData).then((result) => {
					if (result.exist) {
						emailExist = true;
						this.loading = false;
						this.$functions.displayError(
							this,
							this.$t("pages.newInviteSupplier.createInviteNotAllowedWithEmailBindedToCompany", [result.clientName])
						);
						return false;
					}
				});
			}
			if (!emailExist) {
				if (!this.validateInviteInformations() && this.workflowSendsInvite) return;
				// Validar se o workflow contém etapas para todos os atores
				this.validateWorkflow()
					.then(() => {
						this.inviteDetails.email = this.supplierParentEmailSwitch
							? this.supplierParentEmail
							: this.inviteDetails.email;
						this.inviteDetails.inviteType = this.inviteType;
						let mappedObj = this.getInviteCreationObj();
						mappedObj.duplicateSupplier = duplicateSupplier;

						this.createInviteSupplier(mappedObj)
							.then((response) => {
								if (!response.data || !response.data.data || !Object.keys(response.data.data).length) {
									return;
								}

								let isSuccess = response.data.data.isSuccess;
								if (!isSuccess) {
									this.emailSupplier = this.inviteDetails.email;
									this.$bvModal.show("confirmMessage");
									return;
								}

								if (this.offerId) {
									this.updateOfferStatus({
										id: this.offerId,
										status: this.$offerStatus.INVITED,
										login: this.actualUser.idUser
									}).then(() => {
										this.showSucessAfterMail(this.$t("pages.newInviteSupplier.inviteSendedOfferUpdated"));
									});
								} else {
									this.showSucessAfterMail(this.$t("pages.newInviteSupplier.inviteSuccessfullySend"));
								}
								this.$router.push({
									name: "enterpriseList"
								});
							})
							.catch((e) => {
								let errorRequest = { ...e };
								var msg = errorRequest?.response?.data?.error?.message;
								this.$functions.displayError(this, this.$t(msg));
							})
							.finally(() => {
								this.loading = false;
							});
					})
					.catch((error) => {
						console.error(error);
					});
			}
		},
		shouldAssignCnpjCpfToSupplierName() {
			return (
				!this.inviteDetails.supplierName &&
				this.inviteDetails.country === "Brasil" &&
				!this.isMissingReceitaFederalRequirement()
			);
		},
		isMissingReceitaFederalRequirement() {
			return !this.specificRequirements.some((requirement) =>
				[this.$IntegrationIdType.ReceitaFederalCpf, this.$IntegrationIdType.ReceitaFederalCnpj].includes(
					requirement.idIntegration
				)
			);
		},
		isSupplierNameRequired() {
			return (
				!this.inviteDetails.supplierName &&
				this.inviteDetails.country === "Brasil" &&
				this.isMissingReceitaFederalRequirement()
			);
		},
		getInviteEmail: function () {
			return this.supplierParentEmailSwitch ? this.supplierParentEmail : this.inviteDetails.email;
		},
		showSucessAfterMail: function (msg) {
			this.$functions.displaySuccess(this, msg);
			this.cleanChanges();
		},
		validateMessageError: function (data) {
			if (!data.companyName || data.companyName.length == 0)
				return this.$t("pages.newInviteSupplier.saveUpdateFailSelectAtLeastOneCompany");
			if (data.companyName) return this.$t("pages.newInviteSupplier.saveUpdateFailVerifyMandatoryFields");
		},
		applyFilter: function () {
			const filter = {
				...this.filter,
				idWorkflow: this.inviteDetails.idWorkflow
			};
			this.getFamilies(filter).then(() => {
				this.setStatusOnTree();
			});
			this.appliedFilter = true;
		},
		cleanFilter: function () {
			this.filter.NameFilter = "";
			this.filter.ItemCodeFilter = "";
			this.appliedFilter = false;
			this.filterFamiliesByWorkflow(this.inviteDetails.idWorkflow, false);
		},
		applySupplierFilter: function () {
			if (this.supplierFilter.nameFilter.length || this.supplierFilter.cnpjCpfFilter.length) {
				this.getFilteredSuppliers(this.supplierFilter);
			}
		},
		cleanSupplierFilter: function () {
			this.suppliers.splice(0, this.suppliers.length);
			this.supplierFilter.nameFilter = "";
			this.supplierFilter.cnpjCpfFilter = "";
			this.selectedSupplierParent = 0;
		},
		loadList: function () {
			this.getRequirementListByIdInvite(this.idInvite);
		},
		mapBackStatusToFrontStatus(status) {
			let statusObj = {
				statusId: 0,
				statusDescription: "",
				statusVariant: ""
			};
			switch (status) {
				case 0:
				case this.$RequirementStatus.Pending:
					statusObj = {
						statusId: this.$RequirementStatus.Pending,
						statusDescription: this.$t("commons.requirementStatus.pending"),
						statusVariant: "secondary"
					};
					return statusObj;
				case this.$RequirementStatus.InProgress:
					statusObj = {
						statusId: this.$RequirementStatus.InProgress,
						statusDescription: this.$t("commons.requirementStatus.inProgress"),
						statusVariant: "info"
					};
					return statusObj;
				case this.$RequirementStatus.Done:
					statusObj = {
						statusId: this.$RequirementStatus.Done,
						statusDescription: this.$t("commons.requirementStatus.done"),
						statusVariant: "success"
					};
					return statusObj;
				case this.$RequirementStatus.Accepted:
					statusObj = {
						statusId: this.$RequirementStatus.Accepted,
						statusDescription: this.$t("commons.requirementStatus.accepted"),
						statusVariant: "success"
					};
					return statusObj;
				case this.$RequirementStatus.Rejected:
					statusObj = {
						statusId: this.$RequirementStatus.Rejected,
						statusDescription: this.$t("commons.requirementStatus.rejected"),
						statusVariant: "danger"
					};
					return statusObj;
				case this.$RequirementStatus.InReevaluation:
					statusObj = {
						statusId: this.$RequirementStatus.InReevaluation,
						statusDescription: this.$t("commons.requirementStatus.inReevaluation"),
						statusVariant: "warning"
					};
					return statusObj;
				case this.$RequirementStatus.Expired:
					statusObj = {
						statusId: this.$RequirementStatus.Expired,
						statusDescription: this.$t("commons.requirementStatus.expired"),
						statusVariant: "danger"
					};
					return statusObj;
				case this.$RequirementStatus.PartialAnswer:
					statusObj = {
						statusId: this.$RequirementStatus.PartialAnswer,
						statusDescription: this.$t("commons.requirementStatus.partial"),
						statusVariant: "info"
					};
					return statusObj;
				default:
					return statusObj;
			}
		},
		blockEmailField: function () {
			if (
				!this.offerId &&
				((this.newInviteSupplierData.cpf != "" && this.newInviteSupplierData.cpf != null) ||
					(this.newInviteSupplierData.cnpj != "" && this.newInviteSupplierData.cnpj != null))
			) {
				if (this.newInviteSupplierData.email == "" || this.newInviteSupplierData.email == null) return true;
			}
			return false;
		},
		getStepStatus: function (stepId) {
			const props = this.getRequirementProperties();
			let generalRequirementList = this.generalRequirementList;
			let specificRequirementList = this.specificRequirementList;
			let generalRequirementAction = null;
			let specificRequirementAction = null;

			for (let generalRequirement of generalRequirementList) {
				for (let action in generalRequirement?.actions) {
					if (["edit", "validate"].includes(action)) {
						if (generalRequirement.actions[action] === true) {
							generalRequirementAction = action;
						}
					}
				}
			}

			for (let specificRequirement of specificRequirementList) {
				for (let action in specificRequirement?.actions) {
					if (specificRequirement.actions[action] === true) {
						specificRequirementAction = action;
					}
				}
			}

			//GERAIS
			const anyUnfilledRequirementGeneral =
				(props.generalRequirementsProperties.anyNotFilledRequirement ||
					props.generalRequirementsProperties.notObrigatoryRequirements) &&
				generalRequirementAction == "edit";

			const anyNotValidRequirementGeneral =
				props.validateGeneralRequirementsNotValid && generalRequirementAction == "validate";

			//ESPECÍFICOS
			const anyUnfilledRequirementSpecific =
				(props.specificRequirementsProperties.anyNotFilledRequirement ||
					props.specificRequirementsProperties.notObrigatoryRequirements) &&
				specificRequirementAction == "edit";

			const anyNotValidRequirementSpecific =
				props.validateSpecificRequirementsNotValid && specificRequirementAction == "validate";

			if (stepId == 6) {
				if (
					!this.hasTriedToAvanced &&
					(anyUnfilledRequirementGeneral || anyNotValidRequirementGeneral || props.hasGeneralReevaluationRequirements)
				)
					return "uncompleted";
				if (
					this.hasTriedToAvanced &&
					(anyNotValidRequirementGeneral ||
						(anyUnfilledRequirementGeneral && props.generalRequirementsProperties.anyNotFilledRequirement) ||
						props.hasGeneralReevaluationRequirements)
				)
					return "error";
			}

			if (stepId == 7) {
				if (
					!this.hasTriedToAvanced &&
					(anyUnfilledRequirementSpecific ||
						anyNotValidRequirementSpecific ||
						props.hasReevaluationSpecificRequirements)
				)
					return "uncompleted";
				if (
					this.hasTriedToAvanced &&
					(anyNotValidRequirementSpecific ||
						(anyUnfilledRequirementSpecific && props.specificRequirementsProperties.anyNotFilledRequirement) ||
						props.hasReevaluationSpecificRequirements)
				)
					return "error";
			}

			return undefined;
		},
		async saveRegistrationData({ showAlert }) {
			const allFieldsValid = this.$refs.SupplierDetailsKCrud.validateAllFields();
			if (!allFieldsValid) {
				this.$functions.displayError(this, this.$t("pages.newInviteSupplier.warning.mandatoryFillMandatoryFields"));
				this.currentStep = 2;
				this.loading = false;
				return;
			}

			const supplierAddressData = {
				...this.supplierData,
				idSupplier: this.inviteDetails.idSupplier,
				idClient: this.idClient
			};

			try {
				const response = await this.updateSupplierClientAddressStatus(supplierAddressData);
				if (response.isSuccess) {
					this.registrationDataSaved = true;
					if (showAlert) this.$functions.displaySuccess(this, this.$t("messages.updatedSuccessfully"));
				} else {
					if (showAlert) this.$functions.displayError(this, this.$t("messages.changesCouldNotBeSaved"));
				}
				await this.getInvite({ idInvite: this.idInvite });
			} catch (e) {
				this.$functions.displayError(this, this.$t("messages.changesCouldNotBeSaved"));
				console.error(e);
			}
		},
		async loadSupplierDetails() {
			const dataObject = {
				idClient: this.idClient,
				cnpjCpf:
					this.inviteDetails.personType == this.$PersonType.NIF
						? this.inviteDetails.nif
						: this.inviteDetails?.cnpjCpf?.replace(/[^A-Za-z0-9]/g, "").toUpperCase(),
				stateRegistration: this.inviteDetails.stateRegistration,
				municipalRegistration: ""
			};

			if (this.inviteDetails.personType === this.$PersonType.PJ) await this.getIntegrationData();

			this.getSupplierData(dataObject)
				.then((response) => {
					this.supplierCodeERP = response.codeERP;
					this.loadSupplierAddress(response.supplierAddress);
				})
				.finally(() => {
					this.supplierDetailsKey++;
					this.supplierDetailsHasData = true;
					this.navigationKey++;
				});
		},
		async getIntegrationData() {
			await this.getIntegrationById({
				idIntegration: this.$IntegrationIdType.ReceitaFederalCnpj,
				idSupplier: this.inviteDetails.idSupplier
			}).then((result) => {
				this.supplierDetailsHasData = result.integration != null && result.integration.supplierName != null;
				if (this.supplierDetailsHasData) {
					this.supplierData = result.integration;
				}
			});
		},
		loadSupplierAddress(resultAddress) {
			if (resultAddress) {
				this.supplierData = {
					...this.supplierData,
					address: resultAddress.street,
					number: resultAddress.streetNumber,
					complement: resultAddress.complement,
					district: resultAddress.district,
					city: resultAddress.city,
					uf: resultAddress.state,
					zipCode: resultAddress.zipCode,
					country: resultAddress.country
				};
			}
		},
		loadInviteInfos: function (inviteObject, idInvite) {
			this.getWorkflowSendInvite();
			this.loadSupplierDetails();

			if (inviteObject.status == this.$inviteStatus.IN_PROGRESS && inviteObject.currentStepList.length) {
				this.getStepFields(inviteObject.currentStepList[0]);
			}

			// Preencher histórico
			this.$refs.followUpTabComponent?.loadInviteInfos(idInvite);

			// Preencher companies
			this.companyOptions.forEach((group) => {
				group.children.forEach((child) => {
					if (this.inviteDetails.companiesId.indexOf(child.value) != -1) {
						child.selected = true;
						group.selected = true;
					}
				});
			});
			this.oldSelectedCompanies = JSON.parse(JSON.stringify(this.inviteDetails.companiesId));
			this.selectedCompanies = this.inviteDetails.companiesId;

			// Preencher families
			this.setListItensSelectedOnState(this.inviteDetails.familiesId);
			this.oldSelectedFamilies = JSON.parse(JSON.stringify(this.inviteDetails.familiesId));
			this.selectedFamilies = this.inviteDetails.familiesId;
			this.setStatusOnTree();

			// Preencher requisitos específicos
			this.getRequirementListByIdInvite(idInvite);
			if (this.inviteDetails.supplierParent) {
				this.supplierParentEmailSwitch = this.inviteDetails.inviteParentEmail;
				this.getSupplierParent(this.inviteDetails.supplierParent).then((response) => {
					this.setSelectedSupplierParent(response.supplier);
				});
			}

			if (this.inviteDetails.attach) {
				this.getInviteDocument(this.inviteDetails.attach).then((file) => {
					this.fileName = file.fileName;
				});
			}

			const { supplierBank, supplierContact } = inviteObject.supplier;
			this.dataBank = this.formatBankData(supplierBank);
			this.dataContact = this.formatContactData(supplierContact);

			if (this.screenType == this.$inviteTabsType.inviteProcess && this.dataBank.idBank) {
				this.fieldChangeBank(this.dataBank.idBank);
			}
		},
		formatContactData(contact) {
			return {
				idContact: contact?.idContact,
				nameContact: contact.name || this.dataContact.nameContact,
				sector: contact.sector || this.dataContact.sector,
				emailContact: contact.email || this.dataContact.emailContact,
				phoneContact: contact.phone
					? VMasker.toPattern(contact.phone, "(99) 9999-9999")
					: this.dataContact.phoneContact,
				cellphoneContact: contact.cellphone
					? VMasker.toPattern(contact.cellphone, "(99) 99999-9999")
					: this.dataContact.cellphoneContact
			};
		},
		formatBankData(bank) {
			return {
				id: bank?.id,
				nameBank: bank.name || this.dataBank.nameBank,
				bankDescription: bank.bank || this.dataBank.bankDescription,
				idBank: bank.idBank || this.dataBank.idBank,
				agencyDescription: bank.agency || this.dataBank.agencyDescription,
				agencyDigit: bank.agencyDigit || this.dataBank.agencyDigit,
				idAgency: bank.idAgency || this.dataBank.idAgency,
				account: bank.account || this.dataBank.account,
				accountDigit: bank.accountDigit || this.dataBank.accountDigit,
				accountType: bank.accountType === this.$t("commons.currentAccount") ? 1 : bank.accountType ? 2 : 1
			};
		},
		loadRehomologationInfos(idSupplier) {
			const selectedRequirements = this.$functions.requirementsRehomologation();
			this.getSupplierDetailsForRehomologation({
				idSupplier: idSupplier,
				idClient: this.actualUser.idClient,
				requirementIds: selectedRequirements
			}).then((response) => {
				this.idSupplier = idSupplier;
				this.enabledSupplierName = idSupplier == 0;
				this.companyOptions.forEach((group) => {
					group.children.forEach((child) => {
						if (this.inviteDetails.companiesId.indexOf(child.value) != -1) {
							child.selected = true;
							group.selected = true;
						}
					});
				});
				this.oldSelectedCompanies = JSON.parse(JSON.stringify(this.inviteDetails.companiesId));
				this.selectedCompanies = this.inviteDetails.companiesId;
				this.inviteType = this.$InviteType.MANUAL_REHOMOLOGATION;

				const { supplierContact, supplierBank } = response.supplier;
				this.dataContact = this.formatContactData(supplierContact);
				this.dataBank = this.formatBankData(supplierBank);

				this.setListItensSelectedOnState(this.inviteDetails.familiesId);
				this.oldSelectedFamilies = JSON.parse(JSON.stringify(this.inviteDetails.familiesId));
				this.selectedFamilies = this.inviteDetails.familiesId;
				this.setStatusOnTree();
				this.getWorkflowSendInvite();

				if (this.inviteDetails.attach) {
					this.getInviteDocument(this.inviteDetails.attach).then((file) => {
						this.fileName = file.fileName;
					});
				}
				this.inviteDetailsKey++;
			});
		},
		compareByOrdenationAndDescription: function (a, b) {
			if (a.ordenation !== b.ordenation) {
				return a.ordenation - b.ordenation;
			}

			const descriptionCompare = a.description.localeCompare(b.description);
			if (descriptionCompare !== 0) {
				return descriptionCompare;
			}

			return a.idStatus - b.idStatus;
		},
		applyOrderRules: function (a, b, orderRules, canView) {
			for (const rule of orderRules) {
				const bothMatchRule = rule.condition(a) && rule.condition(b);
				const onlyAMatches = rule.condition(a);
				const onlyBMatches = rule.condition(b);

				if (bothMatchRule) {
					if (rule.condition === canView) {
						return a.idStatus - b.idStatus;
					}
					return this.compareByOrdenationAndDescription(a, b);
				} else if (onlyAMatches || onlyBMatches) {
					return onlyAMatches ? rule.order : -rule.order;
				}
			}
			return this.compareByOrdenationAndDescription(a, b);
		},
		sortRequirements: function (requirements) {
			const isPendingAndEditable = (req) =>
				req.idStatus === this.$RequirementStatus.Pending && req.actions.edit && !req.actions.validate;

			const isInReevaluationAndValidatable = (req) =>
				req.idStatus === this.$RequirementStatus.InReevaluation && req.actions.validate && !req.actions.edit;

			const isInReevaluationAndEditable = (req) =>
				req.idStatus === this.$RequirementStatus.InReevaluation && !req.actions.validate && req.actions.edit;

			const isInProgressAndEditableOrValidatable = (req) =>
				(req.idStatus === this.$RequirementStatus.InProgress && req.actions.edit && !req.actions.validate) ||
				(req.idStatus === this.$RequirementStatus.InProgress && req.actions.validate && !req.actions.edit);

			const isDoneAndValidatable = (req) =>
				req.idStatus === this.$RequirementStatus.Done && req.actions.validate && !req.actions.edit;

			const isAcceptedAndValidatable = (req) =>
				req.idStatus === this.$RequirementStatus.Accepted && req.actions.validate && !req.actions.edit;

			const canView = (req) => req.actions.view;

			const orderRules = [
				{ condition: isInReevaluationAndValidatable, order: -1 },
				{ condition: isInReevaluationAndEditable, order: -1 },
				{ condition: isPendingAndEditable, order: -1 },
				{ condition: isInProgressAndEditableOrValidatable, order: -1 },
				{ condition: isDoneAndValidatable, order: -1 },
				{ condition: isAcceptedAndValidatable, order: -1 },
				{ condition: canView, order: 1 }
			];

			return requirements.sort((a, b) => this.applyOrderRules(a, b, orderRules, canView));
		},
		searchBank(event) {
			setTimeout(() => {
				if (!event.query.trim().length) {
					this.standardListBanks = this.standardListBank;
				} else {
					this.standardListBanks = this.standardListBank.filter((bank) => {
						return bank.description.toLowerCase().includes(event.query.toLowerCase());
					});
				}
			}, 250);
		},
		searchAgency(event) {
			setTimeout(() => {
				this.standardListAgencies = this.agenciesList.filter((agency) => {
					return agency.description.toLowerCase().includes(event.query.toLowerCase());
				});
			}, 250);
		},
		selectBankSuggestion(event) {
			this.dataBank.idBank = event.value.idStandardListValue;
			this.fieldChangeBank(this.dataBank.idBank);
		},
		selectAgencySuggestion(event) {
			this.dataBank.idAgency = event.value.idStandardListValue;
		},
		async fieldChangeBank(bankSelected) {
			await this.getStandardListValue({
				idStandardListType: this.$StandardListType.Bank,
				idStandardListValue: bankSelected,
				idClient: this.actualUser.idClient
			}).then((response) => (this.agenciesList = response));
		},
		clearBankSuggestion() {
			this.dataBank.idAgency = null;
			this.dataBank.agencyDescription = "";
			this.dataBank.agencyDigit = null;
			this.standardListAgencies = [];
		},
		async getBank() {
			let banks = await this.getStandardListValueByType(this.$StandardListType.Bank);
			this.setStandardListBankOnState(banks);
		},
		handleTableAnswer(answer) {
			this.$emit("saveAnswer", answer);
		},
		setWorkflowTypeIfHasDefault() {
			if (this.screenType == this.$inviteTabsType.inviteCreation && this.workflowTypes.some((wft) => wft.isDefault)) {
				this.inviteDetails.flowType = this.setWorkflowType;
				this.inviteDetailsKey++;
			}
		},
		getGeneralRequirementDataObject: function (personType, stateRegistration, municipalRegistration, isCustomerInvite) {
			return {
				personType: personType,
				stateRegistration: stateRegistration,
				municipalRegistration: municipalRegistration,
				isCustomerInvite: isCustomerInvite
			};
		},
		processFillerOrValidatorOnReevaluation(requirement) {
			const { status, idFillerActor, idValidateActorList } = requirement;

			return (
				status === this.$RequirementStatus.InReevaluation &&
				idValidateActorList.some((idActor) => parseInt(this.actualStepActor) === idActor) &&
				parseInt(this.actualStepActor) === parseInt(idFillerActor)
			);
		},
		isFieldValidationRequired(fieldName, tab, isValidationForLabel = false) {
			let isRequired = this.screenType == this.$inviteTabsType.inviteProcess;

			if (isRequired) {
				let fieldRules = this.getFieldStructureRules(fieldName, tab);

				switch (fieldRules?.visualizationType) {
					case this.$StepFieldVisualizationType.OBRIGATORY:
						isRequired = true;
						break;
					case this.$StepFieldVisualizationType.DISABLED:
					case this.$StepFieldVisualizationType.OPTIONAL:
						isRequired = false;
						break;
					default:
						isRequired = false;
				}
			}

			if (isValidationForLabel) return isRequired;

			return isRequired && this.userPermissions.update;
		},
		formatMandatoryLabel(label, field, tab) {
			return this.isFieldValidationRequired(field, tab, true) ? `${label} *` : label;
		},
		getFieldStructureRules(fieldName, tab) {
			let fieldRules = this.stepFields.find(
				(sf) => sf.fieldTab === tab && sf.inviteFieldName.toLowerCase() === fieldName.toLowerCase()
			);

			return fieldRules;
		},
		verifyRequirementActedInStep(actualStepIdActor, generalReq) {
			return (
				actualStepIdActor == generalReq.idValidateActor ||
				actualStepIdActor == generalReq.idFillerActor ||
				generalReq.idValidateActorList?.includes(actualStepIdActor)
			);
		},
		showStepDetails({ idStep, stepName, idHistory }) {
			const stepObject = {
				idInvite: parseInt(this.idInvite),
				idStep: parseInt(idStep),
				idClient: this.idClient,
				idHistory: idHistory
			};

			this.getWorkflowHistoryDetailsByStep(stepObject).then((response) => {
				this.$refs.InviteStepHistoryModal.setPropertiesOnModal(response, stepName);
				this.$bvModal.show("inviteStepHistoryModal");
			});
		},
		filterFamiliesTree(selectedFamilies) {
			const originalFamilies = JSON.parse(sessionStorage.getItem("originalFamilies") || "[]");
			const families = this.$functions.filterFamiliesTree(originalFamilies, selectedFamilies);
			this.setFamiliesOnState(families);
			this.setStatusOnTree();
		}
	},
	watch: {
		$route() {
			this.cleanChanges();
		},
		"userPermissions.update": function () {
			this.supplierDetailsKey++;
			this.dataBankKey++;
		},
		"inviteDetails.status": function () {
			this.supplierDetailsKey++;
			this.dataBankKey++;
		},
		availableActions: function () {
			this.supplierDetailsKey++;
			this.dataBankKey++;
		},
		stepFields: function () {
			this.supplierDetailsKey++;
			this.dataBankKey++;
		}
	},
	async beforeMount() {
		this.getBank();
		this.cleanInvite();
		this.cleanSpecificRequirements();
		this.cleanGeneralRequirements();
		this.cleanStepActionsOnState();
		this.cleanContactAndBankSupplier();
		const configurationObj = {
			idClient: this.actualUserIsClient ? this.actualUser.idClient : this.idClient,
			configurationNameList: [
				"SupplierParent",
				"DataBankObrigatority",
				"MunicipalAndStateRegistration",
				"AttachmentEmailInvitation",
				"HideRelationshipTab",
				"MandatoryInviteRegistrationData",
				"OverwriteSupplierClientName",
				"SendCopyInviteEmail",
				"AllowScore",
				"PartialSaving",
				"ExpandFamilyTree",
				"EnableUpperCase"
			]
		};
		await this.getConfigurationByClient(configurationObj);
		if (this.screenType == this.$inviteTabsType.inviteCreation) {
			this.inviteDetails.sendAttachmentEmailInvitation = this.configurations.AttachmentEmailInvitation;
		}

		this.currentStep = this.visibleSteps.shift().id;
		this.inviteType = this.$InviteType.NORMAL_CREATION;
		this.getUfsNoAuth({ idClient: this.actualUser.idClient });
		this.getCountriesNoAuth({ idClient: this.actualUser.idClient }).then(() => {
			// Atualizar KCRUD
			this.inviteDetailsKey++;
		});
		this.getUserPermissionList(this.actualUser.idUser).then((resolve) => {
			const idPermissionEditRegistrationData = 1430;
			this.userHasPermissionToEditRegistrationData = resolve.includes(idPermissionEditRegistrationData);
		});

		if (this.actualUserIsClient && this.screenType != this.$inviteTabsType.inviteProcess) {
			this.getGeneralRequirements(
				this.getGeneralRequirementDataObject(
					this.inviteDetails.personType,
					this.inviteDetails.stateRegistration,
					this.inviteDetails.municipalRegistration,
					true
				)
			);
		}

		const inviteProcess = this.screenType == this.$inviteTabsType.inviteProcess;
		if (this.actualUserIsClient) {
			await this.getFamilies({ overwriteSessionStorage: true, onlyActives: !inviteProcess });
			this.getCompaniesByGroupAndIdInvite(this.idInvite == undefined ? 0 : this.idInvite).then((result) => {
				this.companyOptions = result.map((group) => mapGroup(group, false));
				this.companyOptions.sort((a, b) => (a.text < b.text ? -1 : a.text > b.text ? 1 : 0));
				this.companyOptions.forEach((c) => {
					c.children.sort((a, b) => (a.text < b.text ? -1 : a.text > b.text ? 1 : 0));
				});
			});
			await this.getWorkflows();
			this.getAllWorkflowType().then(() => this.setWorkflowTypeIfHasDefault());
			this.getCompaniesByGroupAndIdInvite(this.idInvite == undefined ? 0 : this.idInvite).then((result) => {
				this.companyOptions = result.map((group) => mapGroup(group, false));
				this.companyOptions.sort(function (a, b) {
					return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
				});
				this.companyOptions.forEach((c) => {
					c.children.sort(function (a, b) {
						return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
					});
				});
			});
		}

		if (this.offerId) this.getOfferCreationData();

		if (inviteProcess) {
			await this.getInvite({ idInvite: this.idInvite }).then(
				(response) => this.loadInviteInfos(response, this.idInvite),
				() => {
					this.$router.replace({
						name: "Unauthorized"
					});
				}
			);
			this.filterFamiliesTree(this.selectedFamilies);
		}

		if (this.supplierId && this.screenType == this.$inviteTabsType.inviteCreation) {
			this.loadRehomologationInfos(this.supplierId);
			this.inviteRehomologation = true;
		}
	},
	destroyed() {
		sessionStorage.removeItem("originalFamilies");
		sessionStorage.removeItem("selectedRequirementsRehomologation");
		this.cleanChanges();
	}
};

function mapGroup(group, selected) {
	return {
		value: group.idCompanyGroup,
		text: group.codeERP + " - " + group.text,
		children: mapChildren(group.children, selected),
		selected: selected,
		isGroup: true
	};
}

function mapChildren(children, selected) {
	let mappedChildren = [];
	children.forEach((child) => {
		mappedChildren.push({
			value: child.idCompany,
			text: child.codeERP + " - " + child.text,
			selected: selected
		});
	});
	return mappedChildren;
}

let newInviteSupplierData = {
	address: null,
	birthDate: null,
	city: null,
	cnpj: null,
	cnpjCpf: null,
	companyName: null,
	complement: null,
	corporationName: null,
	country: null,
	cpf: null,
	district: null,
	email: null,
	message: null,
	family: null,
	flowType: 0,
	name: null,
	personType: 2,
	uf: null,
	workflows: 0,
	zipCode: null,
	attach: 0,
	sendAttachmentEmailInvitation: false,
	sendCopyInviteEmail: false,
	inviteLanguageId: 1
};
const maxLengthWithPontuation = {
	CNPJ: 18,
	CPF: 14
};
</script>

<style scoped>
::v-deep .p-autocomplete-input {
	font-family: Open Sans;
	font-size: 0.75rem !important;
	border-radius: 4px;
}
::v-deep .p-autocomplete-panel {
	font-family: Open Sans;
	font-size: 0.85rem !important;
}
.name-bank {
	margin-left: 8px;
}
.auto-complete-agency {
	width: 100%;
	padding-left: 32px;
}
.auto-complete {
	font-size: 0.6rem !important;
	height: 34px;
}
.input-text {
	font-size: 0.8rem !important;
	height: 33px;
}
.auto-complete-container {
	margin-bottom: 10px;
}
.auto-complete-bank {
	margin-right: 15px;
	width: 90%;
}
.d-stepper-title {
	font-weight: bold;
	color: black;
}
.stepName {
	font-family: "Open Sans";
	font-style: normal;
	font-weight: 600;
	font-size: 16px;
	line-height: 16px;
	color: #1c1637;
	padding-left: 21px;
}
.details {
	display: flex;
	flex-direction: column;
}
.bold {
	font-weight: bold;
}

#addOptionBtn {
	float: right;
}

#saveChangesBtn {
	float: right;
	margin-right: 45px;
}

#cancelBtn {
	float: right;
	margin: 0 16px;
	color: #00648f;
	background-color: white;
	border-color: #00648f;
}

.screenMargin {
	width: 90%;
}

.screenMargin .col {
	padding-left: 9px !important;
}
.added {
	color: #41b883;
}

.filterBtn {
	margin-top: 3rem;
	margin-left: 10px;
}

#deleteItemBtn {
	margin-top: 50px;
}

.wrapper {
	max-height: 162px;
	margin-left: 15px;
}
.wrapper > fieldset {
	margin-bottom: 0.25rem;
}
.wrapper > fieldset > div > div {
	display: flex;
	flex-direction: column;
	overflow-y: scroll;
	max-height: 112px;
	border: 1px solid #666666;
	border-radius: 5px;
	padding: 5px;
}
.wrapper > fieldset > div > div > div {
	display: block;
}

.selectAllCompanies {
	margin-left: 15px;
}
.mt-4 {
	margin-top: 0;
}

.style-tags {
	color: #666666;
	background-color: #ededed;
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 4px 6px;
	gap: 4px;
	font-family: "Open Sans";
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
}

.form-control {
	border: 0;
}

.filterBtn2 {
	float: right;
	margin-bottom: 25px;
}
.actor-tittle {
	padding-right: 8px !important;
	padding-left: 8px !important;
	margin-bottom: -8px !important;
	padding-left: 0px;
	height: 30px;
	display: flex;
	align-items: center;
	color: #fff;
	background-color: #00648f;
	border-color: #00648f;
}

.saveChangesRow {
	max-width: 845px;
	margin-top: 25px;
	margin-bottom: 25px;
}
.listHeader {
	margin-top: 46px;
}

.backBtn {
	margin-left: 9px;
}

.btnRow {
	margin-top: 30px;
	margin-left: 15px;
}

.tableAdjustment {
	padding-left: 24px;
	padding-right: 30px;
}

.customAdjustment {
	padding-left: 9px;
	padding-right: 30px;
}

.btnMarginAdjustment {
	margin-right: 45px !important;
}

.mousePointer {
	cursor: pointer;
}

.no-workflow-message {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 200px;
	border: 1px dashed #ccc;
	border-radius: 4px;
	margin: 20px 0;
}

.alert {
	padding: 15px;
	border-radius: 4px;
	text-align: center;
	max-width: 80%;
}

.alert-info {
	background-color: #e8f4f8;
	border: 1px solid #b8e2ef;
	color: #31708f;
}

::v-deep .auto-complete-bank .p-autocomplete-input:disabled,
::v-deep .auto-complete-agency .p-autocomplete-input:disabled,
::v-deep #agencyDigit:disabled {
	background-color: #e9ecef;
	opacity: 1;
	cursor: not-allowed;
}

::v-deep .kcrud .custom-control-input.is-valid ~ .custom-control-label {
	color: #1c1637;
}
::v-deep .kcrud .custom-control-input.is-valid ~ .custom-control-label::before {
	border-color: #adb5bd;
}
::v-deep .kcrud .custom-control-input.is-valid:checked ~ .custom-control-label::before {
	border-color: #1c1637;
	background-color: #1c1637;
}
</style>
